/* eslint-disable */
import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table";
import { makeStyles } from "@material-ui/core/styles";
import {
  grayColor,
  warningColor,
} from "../../assets/jss/material-dashboard-pro-react.js";
import SearchIcon from "@material-ui/icons/Search";
import {
  AppBar,
  Tabs,
  Tab,
  Typography,
  Box,
  Drawer,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Tooltip,
  TableHead,
  Paper,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  FormControlLabel,
  Checkbox as MuiCheckbox,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Accordion,
  Switch,
  AccordionSummary,
  Divider,
  AccordionDetails,
  Grid,
} from "@material-ui/core";
import {
  Edit as EditIcon,
  Settings,
  Delete as DeleteIcon,
  ExpandMore as ExpandMoreIcon,
  People,
} from "@material-ui/icons";
// Custom components

import GridContainer from "../../components/Grid/GridContainer.js";
import GridItem from "../../components/Grid/GridItem.js";
import { useTranslation } from "react-i18next";
import CardHeader from "../../components/Card/CardHeader.js";
import CardIcon from "../../components/Card/CardIcon.js";
import { cardTitle } from "../../assets/jss/material-dashboard-pro-react.js";
import AddCircle from "@material-ui/icons/AddCircle";
import Button from "components/CustomButtons/Button";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.js";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle";
import AuthContext from "../../contexts/AuthProvider.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CloseIcon from "@material-ui/icons/Close";
import {
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { client } from "../../services/axiosClient";
import Save from "@material-ui/icons/Save";
import cx from "classnames";
import { ThreeDots } from "react-loader-spinner";
import {
  getPermissionHeader,
  getPermissionTooltip,
} from "utils/permissionkeysUtils.js";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";

// TabPanel Component

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`program-setup-tabpanel-${index}`}
      aria-labelledby={`program-setup-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  // VALIDATION OF PROPS

  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

// Accessibility for tabs

function a11yProps(index) {
  return {
    id: `program-setup-tab-${index}`,
    "aria-controls": `program-setup-tabpanel-${index}`,
  };
}

const MAX_APPROVERS_PER_CELL = 2;

export default function ProgramSetup() {
  // console.log(userDetails);
  const { userDetails } = useContext(AuthContext);
  const clientColor = userDetails?.implementation_color;



  const [isLoadingUsers, setisLoadingUsers] = useState(false);

  // Styles

  const ProgramSetupStyles = (theme, clientColor) => ({
    ...customSelectStyle(theme, clientColor),
    ...customInputStyle(clientColor),

    root: {
      flexGrow: 2,
      padding: theme.spacing(2),
    },
    tabsRoot: {
      backgroundColor: grayColor[8],
      //BoxShadow: "0 2px 5px RGBA (0, 0, 0, 0.1)",
    },
    tabRoot: {
      fontSize: "1rem",
      fontWeight: 400,
      color: clientColor,
      textTransform: "none",
      "&:hover": {
        color: clientColor,
        opacity: 1,
      },
      "&.Mui-selected": {
        color: "black",
        fontWeight: 500,
        borderBottom: `2px solid ${clientColor}`,
      },
      "&:focus": {
        color: clientColor,
      },
    },
    indicator: {
      backgroundColor: clientColor,
      height: "1.5px",
    },
    cardIconTitle: {
      ...cardTitle,
      marginTop: "0px",
      marginBottom: "0px",
      padding: "10px",
    },
    addButton: {
      marginBottom: theme.spacing(2),
      height: "22px !important",
      width: "30px !important",
      minWidth: "0 !important",
      position: "relative",
      transition: "all 0.2s",
      margin: "10px 0 0 10px !important",
      padding: "0 !important",
    },
    cardButton: {
      padding: "0 !important",
      margin: "0 !important",
      height: "30px !important",
      width: "30px !important",
      minWidth: "0 !important",
      position: "relative",
      transition: "all 0.2s",
    },
    cardButtonIcon: {
      margin: "0 !important",
      position: "absolute !important",
      top: "50% !important",
      left: "50% !important",
      transform: "translate(-50%, -50%)",
      width: "18px !important",
      height: "18px !important",
    },
    drawer: {
      width: 400,
      padding: theme.spacing(3),
      position: "relative",
    },
    formControl: {
      marginBottom: theme.spacing(2),
      minWidth: 120,
      width: "100%",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: theme.palette.grey[400],
        },
        "&:hover fieldset": {
          borderColor: clientColor,
        },
        "&.Mui-focused fieldset": {
          borderColor: clientColor,
        },
      },
      "& .MuiInputLabel-outlined": {
        color: theme.palette.grey[600],
        "&.Mui-focused": {
          color: theme.palette.grey[500],
        },
      },
      "& .MuiOutlinedInput-input::placeholder": {
        color: theme.palette.grey[600],
        opacity: 1,
      },
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
    iconButtonCustom: {
      cursor: "pointer",
      "&:hover": {
        color: clientColor,
      },
    },
    actionIconsCustom: {
      display: "flex",
      gap: theme.spacing(1),
      justifyContent: "center",
      alignItems: "center",
    },
    center: {
      textAlign: "center",
    },
    tableHeadCell: {
      fontWeight: "bold",
      backgroundColor: "white",
      cursor: "pointer", // Indicates that the cell is clickable
    },
    sortIndicator: {
      marginLeft: theme.spacing(1),
      fontSize: "0.8rem",
    },
    filterContainer: {
      marginBottom: theme.spacing(2),
      display: "flex",
      alignItems: "center",
    },
    filterItem: {
      marginRight: theme.spacing(2),
      minWidth: 200,
    },
    accordionRootCustom: {
      marginBottom: theme.spacing(0.2),
      overflow: "hidden",
      boxShadow: "none", // Removes the shadow

      "&:before": {
        display: "none", // Removes the line before Accordion (if any)
      },
      // For the first Accordion:

      "&:first-of-type": {
        borderRadius: "10px 10px 10px 10px", // Applies radius only at the top
      },
      // For the last Accordion:

      "&:last-of-type": {
        borderRadius: "10px 10px 10px 10px", // Applies radius only at the bottom
      },
    },
    textFieldRoot: {
      "& .MuiInput-underline:before": {
        borderBottom: "1px solid #ccc", // Lower Border Standard Color
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottom: `2px solid ${clientColor}`, // Color when passing the mouse
      },
      "& .MuiInput-underline:after": {
        borderBottom: `2px solid ${clientColor}`, // Color when selected
      },
    },
    inputText: {
      color: "#666", // Standard text color

      "&:focus": {
        color: "#666", // Text color when selected
      },
    },
    labelText: {
      color: "#666", // LABEL STANDARD COLOR

      "&.Mui-focused": {
        color: "#666", // LABEL COLOR When focused
      },
    },
    sortIcon: {
      fontSize: "14px",
      marginLeft: "6px",
      color: "#ccc",
    },
    activeSortIcon: {
      color: "#aaa",
    },
    loadingAnimation: {
      animation: "$loadingAnimation 4.0s ease-in-out infinite",
    },

    attention: {
      backgroundColor: warningColor[0] + " !important",
      animation: "$attention 3s ease infinite",
    },
    "@keyframes attention": {
      "10%": {
        transform: "scale(1.1)",
      },
      "13.33%,20%": {
        transform: "rotate(-10deg) scale(1.1)",
      },
      "16.67%": {
        transform: "rotate(10deg) scale(1.1)",
      },
      "23.33%": {
        transform: "rotate(0deg) scale(1.1)",
      },
      "33%": {
        transform: "scale(1)",
      },
    },

    actionDisabled: {
      opacity: "0.5 !important",
      pointerEvents: "none",
    },
    checkboxRoot: {
      // Estilo geral se necessário
      // padding: '0px', // Se quiser remover padding
    },
    checkboxCheckedClient: {
      // Cor quando checado
      color: `${clientColor} !important`, // Use !important se necessário para sobrescrever
    },
    kpiDrawerDividerContainer: {
      display: "flex",
      alignItems: "center",
      margin: `${theme.spacing(3)}px 0px ${theme.spacing(2)}px 0px`, // Ajuste o espaçamento (top, x, bottom, x)
    },
    kpiDrawerDividerLine: {
      flexGrow: 1,
      height: "1px",
      backgroundColor: clientColor ? clientColor : theme.palette.grey[300], // Cor do cliente ou cinza
      opacity: 0.6,
    },
    kpiDrawerDividerText: {
      padding: `0 ${theme.spacing(1.5)}px`,
      fontWeight: 500,
      color: clientColor ? clientColor : theme.palette.text.secondary, // Cor do cliente ou cor secundária do texto
      fontSize: "0.9rem", // Tamanho da fonte para o texto do divisor
      textTransform: "uppercase", // Opcional: para deixar o texto em maiúsculas
      letterSpacing: "0.5px", // Opcional: espaçamento entre letras
    },
    searchIcon: {
      color: grayColor[1],
      fontSize: "1.3rem",
    },
    ellipsisCell: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "250px", // Adjust width as needed
    },
    stickyHeaderCell: {
      position: "sticky",
      top: 0,
      zIndex: 10,
      backgroundColor: "white", // Or your desired header background
      borderBottom: "1px solid #ddd", // Add a border for visual separation
    },

    stickyFirstColumnCell: {
      position: "sticky",
      left: 0,
      zIndex: 5, // Lower zIndex than header
      backgroundColor: "white",
      borderRight: "1px solid #ddd", // Add a border for visual separation
    },

    checkboxDisabled: {
      // This style will be applied when the checkbox's disabled prop is true
      color: `${grayColor[1]} !important`, // Using a gray color from your theme
    },
    attention: {
      backgroundColor: `${warningColor[0]} !important`, // Yellow attention color
      animation: "$attention 3s ease infinite",
    },
    "@keyframes attention": {
      "10%": {
        transform: "scale(1.1)",
      },
      "13.33%, 20%": {
        transform: "rotate(-10deg) scale(1.1)",
      },
      "16.67%": {
        transform: "rotate(10deg) scale(1.1)",
      },
      "23.33%": {
        transform: "rotate(0deg) scale(1.1)",
      },
      "33%": {
        transform: "scale(1)",
      },
    },
    checkboxRoot: {
      // General style if needed, can be empty
    },

    checkboxCheckedClient: {
      // Color when the checkbox is checked and enabled
      color: `${clientColor} !important`,
    },
    checkboxDisabled: {
      // Color when the checkbox is disabled (will apply to both checked and unchecked states)
      color: `${grayColor[2]} !important`,
    },
  });

  const client_styles = (theme) => ({
    ...ProgramSetupStyles(theme, userDetails.implementation_color),
  });

  const useStyles = makeStyles(client_styles);
  const classes = useStyles();

  // ----------------------------------------------------------
  // Multi Select Component Styles
  // ----------------------------------------------------------
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "80px",
      maxHeight: "80px", // Maximum field height

      maxWidth: "400px", // Maximum field width

      overflowY: "auto",
      boxSizing: "border-box",
      borderColor: state.isFocused ? clientColor : provided.borderColor, // Change Border Color When Focusing

      backgroundColor: "white", // field background

      "&:hover": {
        borderColor: clientColor, // Border color when passing the mouse
      },
    }),
    menu: (provided) => ({
      ...provided,
      //MaxHeight: "200px", //Dropdown Max Height

      overflowY: "auto", // internal scroll when many options

      backgroundColor: "white",
      boxSizing: "border-box",
    }),
    option: (provided, state) => ({
      ...provided,
      //color: state.isSelected ? "white" : "black",

      color: state.isSelected
        ? "black"
        : state.isFocused
          ? "white" // Over mouse color on Dropdown items
          : "black",
      backgroundColor: state.isSelected
        ? "gray"
        : state.isFocused
          ? clientColor // Over mouse color on Dropdown items
          : "white", // Color of the list not selected on Dropdown

      "&:active": {
        transform: "scale(0.95)", // Give a "sunk" on the button by clicking

        transition: "transform 0.2s ease",
        // You can also change the color if you want to differentiate when clicking:

        backgroundColor: clientColor,
      },
    }),

    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#d3d3d3", // Background color of selected tags
    }),

    multiValueLabel: (provided) => ({
      ...provided,
      color: "black", // Text color inside tags
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "black",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  const { t } = useTranslation(); // HOOK FOR TRANSLATION

  const [tabValue, setTabValue] = useState(0);

  // State for unsaved changes confirmation (universal)

  const [unsavedDialogOpen, setUnsavedDialogOpen] = useState(false);
  const [onDiscardConfirm, setOnDiscardConfirm] = useState(null);
  const [onDiscardCancel, setOnDiscardCancel] = useState(null);

  // States for Branches

  const [branches, setBranches] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [isLoadingBranches, setIsLoadingBranches] = useState(true);
  const [branchDrawerOpen, setBranchDrawerOpen] = useState(false);
  const [newBranch, setNewBranch] = useState({
    name: "",
    leader: "",
    description: "",
  });
  const [hasUnsavedBranchChanges, setHasUnsavedBranchChanges] = useState(false);
  const [editingBranchId, setEditingBranchId] = useState(null); // BRANCH ID being edited

  // States for Workfrones

  const [workfronts, setWorkfronts] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [isLoadingWorkfronts, setIsLoadingWorkfronts] = useState(false);
  const [workfrontDrawerOpen, setWorkfrontDrawerOpen] = useState(false);
  const [newWorkfront, setNewWorkfront] = useState({
    name: "",
    leader: "",
    branch: "",
    startDate: "",
    endDate: "",
    description: "",
  });
  // Track unsaved changes (only used in edit mode)

  const [hasUnsavedWorkfrontChanges, setHasUnsavedWorkfrontChanges] =
    useState(false);

  const [editingWorkfrontId, setEditingWorkfrontId] = useState(null);

  // State for the Branch filter on the Workfronts tab

  const [workfrontFilterBranch, setWorkfrontFilterBranch] = useState("");

  // States for Approval Flow

  const [approvalLevels, setApprovalLevels] = useState([]);
  const [approvalFlow, setApprovalFlow] = useState({});
  const [approvalDrawerOpen, setApprovalDrawerOpen] = useState(false);
  const [newApprovalLevel, setNewApprovalLevel] = useState({ name: "" });
  const [hasUnsavedApprovalLevelChanges, setHasUnsavedApprovalLevelChanges] =
    useState(false);
  const [editingApprovalLevelId, setEditingApprovalLevelId] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [isLoadingApprovalLevels, setIsLoadingApprovalLevels] = useState(false);
  const [hasApproverChanges, setHasApproverChanges] = useState(false);
  const [isSavingApprovers, setIsSavingApprovers] = useState(false);

  // States for KPIs

  // States for KPIs
  const [programKPIs, setProgramKPIs] = useState([]);
  const [programKPIDrawerOpen, setProgramKPIDrawerOpen] = useState(false);

  // [CHANGED] We will keep the KPI fields but unify thresholds in an array structure
  // [CHANGED] Example of a unified "newProgramKPI" state
  const initialNewProgramKPIState = {
    name: "",
    description: "",
    unit: "",
    type: "program",
    subtype: "",
    is_cumulative: true,
    reporting_format: "initiative",
    performance_orientation: "", // ASC, DESC, MOD

    // Campos para GREEN (para todas as orientações)
    green_min_value: "", // Usado como Min para MOD/Between; valor único para ASC (Above) ou DESC (Below)
    green_max_value: "", // Usado como Max para MOD/Between Green

    // Campos para YELLOW (Faixa 1 para todas as orientações; Faixa 2 só para MOD)
    yellow_min_value_1: "", // Min da Faixa 1 (ou valor único para ASC/DESC Yellow)
    yellow_max_value_1: "", // Max da Faixa 1 (ou valor único para ASC/DESC Yellow)
    yellow_min_value_2: "", // Modular - Yellow Faixa 2 - Min
    yellow_max_value_2: "", // Modular - Yellow Faixa 2 - Max

    // Campos para RED
    red_value_below: "", // Para DESC Red (Above X), ASC Red (Below X), MOD Red (Below P)
    red_value_above: "", // Apenas para MOD Red (Acima de Q)

    red_threshold_value: "", // Usado para ASC (Below X) e DESC (Above X)
    // Para RED MODULAR (<P OU >Q)
    red_modular_below_value: "", // P
    red_modular_above_value: "", // Q
  };
  const [newProgramKPI, setNewProgramKPI] = useState(initialNewProgramKPIState);

  const [kpiTypeOptions, setKpiTypeOptions] = useState([]);
  const [kpiSubTypeOptions, setKpiSubTypeOptions] = useState([]);

  const [filterKpiType, setFilterKpiType] = useState("");

  const filteredProgramKPIs = programKPIs.filter((kpi) => {
    const typeMatch = filterKpiType ? kpi.type === filterKpiType : true;
    // Adicione aqui a lógica para filtrar pelo subtipo se você adicionar um filtro para ele
    // const subtypeMatch = filterKpiSubtype ? kpi.subtype === filterKpiSubtype : true;
    return typeMatch;
  });

  // STATES FOR IMPACTS

  const [impacts, setImpacts] = useState([]);
  const [impactDrawerOpen, setImpactDrawerOpen] = useState(false);
  const [newImpact, setNewImpact] = useState({
    impact: "",
    description: "",
  });
  const [editingImpactId, setEditingImpactId] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [isLoadingImpacts, setIsLoadingImpacts] = useState(false);
  const [sortConfigImpacts, setSortConfigImpacts] = useState({
    key: null,
    direction: null,
  });
  const [hasUnsavedImpactChanges, setHasUnsavedImpactChanges] = useState(false);

  // States for Ordination

  const [sortConfigBranches, setSortConfigBranches] = useState({
    key: null,
    direction: null,
  });
  const [sortConfigWorkfronts, setSortConfigWorkfronts] = useState({
    key: null,
    direction: null,
  });
  const [sortConfigApprovalLevels, setSortConfigApprovalLevels] = useState({
    key: null,
    direction: null,
  });
  const [sortConfigProgramKPIs, setSortConfigProgramKPIs] = useState({
    key: null,
    direction: null,
  });

  // Tabs

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Handlers para Branches

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    setIsLoadingBranches(true);
    try {
      const response = await client.post("/api/branches/", { action: "list" });
      const data = response.data;

      if (data.success && Array.isArray(data.branches)) {
        setBranches(
          data.branches.map((branch) => ({
            id: branch.id,
            name: branch.name,
            leaderName: branch.leader || "-", // Name of Leader or PlaceHolder

            leaderId: branch.leader_id || null, // Leader or null ID

            description: branch.description,
          }))
        );
      } else {
        console.error("Branches não é um array ou success é false");
        setBranches([]); // Defines as an empty array in case of error
      }
    } catch (error) {
      console.error("Erro ao buscar branches:", error);
      setBranches([]); // Defines as an empty array in case of error
    } finally {
      setIsLoadingBranches(false);
    }
  };

  const handleOpenBranchDrawer = () => {
    setEditingBranchId(null); // Cleans any previous edition

    setNewBranch({
      name: "",
      leader: "",
      description: "",
    });
    setBranchDrawerOpen(true);
  };

  const handleCloseBranchDrawer = () => {
    setHasUnsavedBranchChanges(false);
    setBranchDrawerOpen(false);
    setEditingBranchId(null);
    setNewBranch({
      name: "",
      leader: "",
      description: "",
    });
  };

  const handleBranchChange = (e) => {
    setNewBranch({
      ...newBranch,
      [e.target.name]: e.target.value,
    });
    // Mark unsaved changes if editing

    if (editingBranchId !== null) {
      setHasUnsavedBranchChanges(true);
    }
  };

  useEffect(() => {
    if (branchDrawerOpen && editingBranchId === null) {
      // We are in NEW mode, try load from localStorage

      const stored = localStorage.getItem("draftBranch");
      if (stored) {
        setNewBranch(JSON.parse(stored));
      }
    }
  }, [branchDrawerOpen, editingBranchId]);

  useEffect(() => {
    if (branchDrawerOpen && editingBranchId === null) {
      // store as user types

      localStorage.setItem("draftBranch", JSON.stringify(newBranch));
    }
  }, [branchDrawerOpen, editingBranchId, newBranch]);

  const handleSaveBranch = async () => {
    const payload = {
      action: editingBranchId ? "update" : "create",
      id: editingBranchId,
      name: newBranch.name,
      description: newBranch.description,
      leader_id: newBranch.leader, // Selected Leader ID
    };

    try {
      const response = await client.post("/api/branches/", payload);
      if (response.data.success) {
        fetchBranches(); // Update Branches List

        if (editingBranchId === null) {
          localStorage.removeItem("draftBranch");
        }
        handleCloseBranchDrawer();
      } else {
        console.error("Erro ao salvar branch:", response.data.error);
      }
    } catch (error) {
      console.error("Erro ao salvar branch:", error);
    }
  };

  const handleEditBranch = (branch) => {
    setEditingBranchId(branch.id);

    setNewBranch({
      name: branch.name || "",
      description: branch.description || "",
      leader: branch.leaderId || null, // Guarantees that Leaderid is assigned
    });

    setBranchDrawerOpen(true);
  };

  const handleDeleteBranch = async (branchId) => {
    try {
      const response = await client.post("/api/branches/", {
        action: "delete",
        id: branchId,
      });
      const data = response.data;
      if (data.success) {
        // Recharge the Backend list after exclusion

        await fetchBranches();
      } else {
        console.error("Erro ao deletar branch:", data);
      }
    } catch (error) {
      console.error("Erro ao deletar branch:", error);
    }
  };

  // Handlers for Workfronts

  useEffect(() => {
    fetchWorkfronts();
  }, []);

  const fetchWorkfronts = async () => {
    setIsLoadingWorkfronts(true);
    try {
      const response = await client.post("/api/workfronts/", {
        action: "list",
      });
      const data = response.data;

      if (data.success && Array.isArray(data.workfronts)) {
        setWorkfronts(
          data.workfronts.map((workfront) => ({
            id: workfront.id,
            name: workfront.name,
            leader: workfront.leader || "-", // Name of Leader or PlaceHolder

            leaderId: workfront.leader_id || null, // Leader or null ID

            branch: workfront.branch,
            startDate: workfront.startDate,
            endDate: workfront.endDate,
            description: workfront.description,
          }))
        );
      } else {
        console.error("Workfronts não é um array ou success é false");
        setWorkfronts([]);
      }
    } catch (error) {
      console.error("Erro ao buscar workfronts:", error);
      setWorkfronts([]);
    } finally {
      setIsLoadingWorkfronts(false);
    }
  };

  const handleOpenWorkfrontDrawer = () => {
    setEditingWorkfrontId(null);
    setNewWorkfront({
      name: "",
      leader: "",
      branch: "",
      startDate: "",
      endDate: "",
      description: "",
    });
    setWorkfrontDrawerOpen(true);
    // reset unsaved changes

    setHasUnsavedWorkfrontChanges(false);
  };

  const handleCloseWorkfrontDrawer = () => {
    // reset unsaved changes

    setHasUnsavedWorkfrontChanges(false);
    setWorkfrontDrawerOpen(false);
    setEditingWorkfrontId(null);
    setNewWorkfront({
      name: "",
      leader: "",
      branch: "",
      startDate: "",
      endDate: "",
      description: "",
    });
  };

  const handleWorkfrontChange = (e) => {
    setNewWorkfront({
      ...newWorkfront,
      [e.target.name]: e.target.value,
    });
    // if editing an existing ID, mark unsaved

    if (editingWorkfrontId !== null) {
      setHasUnsavedWorkfrontChanges(true);
    }
  };

  // Load from localStorage if this is a NEW workfront

  useEffect(() => {
    if (workfrontDrawerOpen && editingWorkfrontId === null) {
      const stored = localStorage.getItem("draftWorkfront");
      if (stored) {
        setNewWorkfront(JSON.parse(stored));
      }
    }
  }, [workfrontDrawerOpen, editingWorkfrontId]);

  // Save to localStorage if this is a NEW workfront

  useEffect(() => {
    if (workfrontDrawerOpen && editingWorkfrontId === null) {
      localStorage.setItem("draftWorkfront", JSON.stringify(newWorkfront));
    }
  }, [workfrontDrawerOpen, editingWorkfrontId, newWorkfront]);

  const handleSaveWorkfront = async () => {
    const payload = {
      action: editingWorkfrontId !== null ? "update" : "create",
      id: editingWorkfrontId,
      name: newWorkfront.name,
      description: newWorkfront.description,
      startDate: newWorkfront.startDate,
      endDate: newWorkfront.endDate,
      branch: newWorkfront.branch,
      leader_id: newWorkfront.leader, // Leader id
    };

    try {
      const response = await client.post("/api/workfronts/", payload);
      if (response.data.success) {
        await fetchWorkfronts();
        if (editingWorkfrontId === null) {
          // Remove LocalStorage for New

          localStorage.removeItem("draftWorkfront");
        }
        handleCloseWorkfrontDrawer();
      } else {
        console.error("Erro ao salvar workfront:", response.data.error);
      }
    } catch (error) {
      console.error("Erro ao salvar workfront:", error);
    }
  };

  const handleEditWorkfront = (workfront) => {
    setEditingWorkfrontId(workfront.id);
    setNewWorkfront({
      name: workfront.name || "",
      leader: workfront.leaderId || null, // Ensures that the leader is attributed correctly

      branch: workfront.branch || "",
      startDate: workfront.startDate || "",
      endDate: workfront.endDate || "",
      description: workfront.description || "",
    });
    setWorkfrontDrawerOpen(true);
  };

  const handleDeleteWorkfront = async (workfrontId) => {
    try {
      const response = await client.post("/api/workfronts/", {
        action: "delete",
        id: workfrontId,
      });
      const data = response.data;
      if (data.success) {
        // Update the list after the deletion

        await fetchWorkfronts();
      } else {
        console.error("Erro ao deletar workfront:", data);
      }
    } catch (error) {
      console.error("Erro ao deletar workfront:", error);
    }
  };

  // Handlers for Approval Flow

  useEffect(() => {
    fetchApprovalLevels();
  }, []);

  const fetchApprovalLevels = async () => {
    setIsLoadingApprovalLevels(true);
    try {
      const response = await client.post("/api/approvalgates/", {
        action: "list",
      });
      const data = response.data;
      if (data.success) {
        setApprovalLevels(data.gates); // Data.Gates is an array of {id, name}

        setApprovalFlow(data.approvalFlow); // data.approvalFlow é no formato {branchId: {gateId: [userIds...]}}
      } else {
        console.error("Erro ao carregar approval levels");
        setApprovalLevels([]);
        setApprovalFlow({});
      }
    } catch (error) {
      console.error("Erro ao buscar approval levels:", error);
      setApprovalLevels([]);
      setApprovalFlow({});
    } finally {
      setIsLoadingApprovalLevels(false);
    }
  };

  const handleOpenApprovalDrawer = () => {
    setEditingApprovalLevelId(null);
    setNewApprovalLevel({ name: "" });
    setApprovalDrawerOpen(true);
    setHasUnsavedApprovalLevelChanges(false);
  };

  const handleCloseApprovalDrawer = () => {
    setEditingApprovalLevelId(null);
    setNewApprovalLevel({ name: "" });
    setHasUnsavedApprovalLevelChanges(false);
    setApprovalDrawerOpen(false);
  };

  const handleApprovalLevelChange = (e) => {
    setNewApprovalLevel({
      ...newApprovalLevel,
      [e.target.name]: e.target.value,
    });
    if (editingApprovalLevelId !== null) {
      setHasUnsavedApprovalLevelChanges(true);
    }
  };

  // Location IF New

  useEffect(() => {
    if (approvalDrawerOpen && editingApprovalLevelId === null) {
      const stored = localStorage.getItem("draftApprovalLevel");
      if (stored) {
        setNewApprovalLevel(JSON.parse(stored));
      }
    }
  }, [approvalDrawerOpen, editingApprovalLevelId]);

  useEffect(() => {
    if (approvalDrawerOpen && editingApprovalLevelId === null) {
      localStorage.setItem(
        "draftApprovalLevel",
        JSON.stringify(newApprovalLevel)
      );
    }
  }, [approvalDrawerOpen, editingApprovalLevelId, newApprovalLevel]);

  const handleEditApprovalLevel = (level) => {
    setEditingApprovalLevelId(level.id);
    setNewApprovalLevel({ name: level.name });
    setApprovalDrawerOpen(true);
  };

  const handleSaveApprovalLevel = async () => {
    const action = editingApprovalLevelId !== null ? "update" : "create";
    const payload = {
      action,
      id: editingApprovalLevelId,
      name: newApprovalLevel.name,
    };

    try {
      const response = await client.post("/api/approvalgates/", payload);
      const data = response.data;
      if (data.success) {
        await fetchApprovalLevels();
        if (editingApprovalLevelId === null) {
          localStorage.removeItem("draftApprovalLevel");
        }
        handleCloseApprovalDrawer();
      } else {
        console.error("Erro ao salvar approval level:", data);
      }
    } catch (error) {
      console.error("Erro ao salvar approval level:", error);
    }
  };

  const handleDeleteApprovalLevel = async (approvalLevelId) => {
    try {
      const response = await client.post("/api/approvalgates/", {
        action: "delete",
        id: approvalLevelId,
      });
      const data = response.data;
      if (data.success) {
        // Updates the list after deletion

        await fetchApprovalLevels();
      } else {
        console.error("Erro ao deletar approval level:", data);
      }
    } catch (error) {
      console.error("Erro ao deletar approval level:", error);
    }
  };

  // Handler to change approvals in a specific cell

  const handleApprovalFlowChange = (branchId, levelId, selectedOptions) => {
    const selectedUserIds = selectedOptions
      ? selectedOptions.map((o) => o.value)
      : [];
    if (selectedUserIds.length > MAX_APPROVERS_PER_CELL) {
      toast.error(
        `Você pode selecionar no máximo ${MAX_APPROVERS_PER_CELL} aprovadores.`,
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        }
      );
      return;
    }

    setApprovalFlow((prevFlow) => ({
      ...prevFlow,
      [branchId]: {
        ...prevFlow[branchId],
        [levelId]: selectedUserIds,
      },
    }));
    setHasApproverChanges(true);
  };

  // Function to save in Backend the changes of approvals

  const handleSaveApprovers = async () => {
    setIsSavingApprovers(true);
    try {
      const response = await client.post("/api/approvalgates/", {
        action: "updateApprovers",
        approvalFlow: approvalFlow,
      });
      const data = response.data;
      if (data.success) {
        toast.success("Aprovadores atualizados com sucesso!");
        setHasApproverChanges(false); // Reset after saving
      } else {
        console.error("Erro ao atualizar aprovadores:", data);
      }
    } catch (error) {
      console.error("Erro ao atualizar aprovadores:", error);
    } finally {
      setIsSavingApprovers(false);
    }
  };

  // Handlers for Program KPIs
  // Function to load Backend KPIs

  // Controls for unsaved changes, edition, and loading states
  const [hasUnsavedKPIChanges, setHasUnsavedKPIChanges] = useState(false);
  const [editingProgramKPIId, setEditingProgramKPIId] = useState(null);
  const [isLoadingKPIs, setIsLoadingKPIs] = useState(false);
  const [isSavingKpi, setIsSavingKpi] = useState(false); // [ADDED]

  // DENTRO DE fetchKPIChoices:
  const fetchKPIChoices = async () => {
    try {
      const response = await client.post("/api/kpis/", {
        action: "get_choices",
      });
      const data = response.data;

      if (data.success) {
        setKpiTypeOptions(
          data.typeChoices?.map((choice) => ({
            ...choice,
            label: t(`kpi.type.${choice.value}`, choice.label),
          })) || []
        );
        setKpiSubTypeOptions(
          data.subtypeChoices?.map((choice) => ({
            ...choice,
            label: t(`kpi.subtype.${choice.value}`, choice.label),
          })) || []
        );
      } else {
        setKpiTypeOptions([]);
        setKpiSubTypeOptions([]);
        console.error("Erro ao carregar opções de KPI:", data.error);
        toast.error(t("program_setup.kpis.errors.load_choices_failed"));
      }
    } catch (error) {
      console.error("Erro ao buscar opções de KPIs:", error);
      toast.error(t("program_setup.kpis.errors.load_choices_failed"));
    }
  };

  const kpiPerformanceOrientationOptions = [
    {
      value: "ASC",
      label: t(
        "program_setup.kpis.performance_orientation.asc",
        "Ascending (Higher is better)"
      ),
    },
    {
      value: "DESC",
      label: t(
        "program_setup.kpis.performance_orientation.desc",
        "Descending (Lower is better)"
      ),
    },
    {
      value: "MOD",
      label: t(
        "program_setup.kpis.performance_orientation.mod",
        "Modular (Target is a range)"
      ),
    },
  ];

  const reportingFormatOptions = [
    {
      value: "initiative",
      label: t("kpi.reporting_format.initiative", "By Initiative"),
    },
    {
      value: "centralized",
      label: t("kpi.reporting_format.centralized", "Centralized"),
    },
  ];

  useEffect(() => {
    // If reporting format is set to 'centralized', force type to 'program'
    if (
      newProgramKPI.reporting_format === "centralized" &&
      newProgramKPI.type !== "program"
    ) {
      setNewProgramKPI((prev) => ({ ...prev, type: "program" }));
    }
  }, [newProgramKPI.reporting_format]);

  useEffect(() => {
    fetchKPIs();
    fetchKPIChoices();
  }, []);

  // Load existing KPIs
  const fetchKPIs = async () => {
    setIsLoadingKPIs(true);
    try {
      const response = await client.post("/api/kpis/", { action: "list" });
      const data = response.data;
      if (data.success && Array.isArray(data.kpis)) {
        setProgramKPIs(data.kpis);
      } else {
        console.error("Erro ao carregar KPIs");
        setProgramKPIs([]);
      }
    } catch (error) {
      console.error("Erro ao buscar KPIs:", error);
      setProgramKPIs([]);
    } finally {
      setIsLoadingKPIs(false);
    }
  };

  // Handler to open the Drawer for a new KPI
  const handleOpenProgramKPIDrawer = () => {
    setEditingProgramKPIId(null);
    setNewProgramKPI(initialNewProgramKPIState); // Usa o estado inicial
    setProgramKPIDrawerOpen(true);
    setHasUnsavedKPIChanges(false);
  };

  // Handler to close the Drawer
  const handleCloseProgramKPIDrawer = () => {
    setEditingProgramKPIId(null);
    setNewProgramKPI(initialNewProgramKPIState); // Usa o estado inicial
    setHasUnsavedKPIChanges(false);
    setProgramKPIDrawerOpen(false);
  };
  // Handler for changes in form fields
  const handleProgramKPIChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewProgramKPI((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setHasUnsavedKPIChanges(true);
  };

  // If the drawer is open for a "new" KPI, load the local draft if it exists
  useEffect(() => {
    if (programKPIDrawerOpen && editingProgramKPIId === null) {
      const stored = localStorage.getItem("draftProgramKPI");
      if (stored) {
        setNewProgramKPI(JSON.parse(stored));
      }
    }
  }, [programKPIDrawerOpen, editingProgramKPIId]);

  useEffect(() => {
    if (programKPIDrawerOpen && editingProgramKPIId === null) {
      localStorage.setItem("draftProgramKPI", JSON.stringify(newProgramKPI));
    }
  }, [programKPIDrawerOpen, editingProgramKPIId, newProgramKPI]);

  // [CHANGED] Now we build the thresholds as an ARRAY, similarly to NewInitiativeForm
  const handleSaveProgramKPI = async () => {
    setIsSavingKpi(true);

    if (
      !newProgramKPI.name ||
      !newProgramKPI.type ||
      !newProgramKPI.subtype ||
      !newProgramKPI.performance_orientation
    ) {
      toast.error(t("program_setup.kpis.errors.required_fields_missing"));
      setIsSavingKpi(false);
      return;
    }

    const thresholdsToSend = [];
    const orientation = newProgramKPI.performance_orientation;

    const parseVal = (valStr) => {
      if (valStr === "" || valStr === null || valStr === undefined) return null;
      const num = parseFloat(valStr);
      return isNaN(num) ? null : num / 100;
    };

    // GREEN
    if (orientation === "ASC") {
      if (newProgramKPI.green_min_value)
        thresholdsToSend.push({
          color: "green",
          mode: "above",
          min_value: parseVal(newProgramKPI.green_min_value),
          max_value: null,
        });
    } else if (orientation === "DESC") {
      if (newProgramKPI.green_min_value)
        thresholdsToSend.push({
          color: "green",
          mode: "below",
          min_value: null,
          max_value: parseVal(newProgramKPI.green_min_value),
        });
    } else if (orientation === "MOD") {
      if (newProgramKPI.green_min_value || newProgramKPI.green_max_value) {
        thresholdsToSend.push({
          color: "green",
          mode: "between",
          min_value: parseVal(newProgramKPI.green_min_value),
          max_value: parseVal(newProgramKPI.green_max_value),
        });
      }
    }

    // YELLOW
    if (newProgramKPI.yellow_min_value_1 || newProgramKPI.yellow_max_value_1) {
      // Faixa 1 (obrigatória se preenchida)
      thresholdsToSend.push({
        color: "yellow",
        mode: "between",
        min_value: parseVal(newProgramKPI.yellow_min_value_1),
        max_value: parseVal(newProgramKPI.yellow_max_value_1),
      });
    }
    if (
      orientation === "MOD" &&
      (newProgramKPI.yellow_min_value_2 || newProgramKPI.yellow_max_value_2)
    ) {
      // Faixa 2 para MOD
      thresholdsToSend.push({
        color: "yellow",
        mode: "between",
        min_value: parseVal(newProgramKPI.yellow_min_value_2),
        max_value: parseVal(newProgramKPI.yellow_max_value_2),
      });
    }

    // RED
    if (orientation === "ASC") {
      // Abaixo de X
      if (newProgramKPI.red_threshold_value)
        thresholdsToSend.push({
          color: "red",
          mode: "below",
          min_value: null,
          max_value: parseVal(newProgramKPI.red_threshold_value),
        });
    } else if (orientation === "DESC") {
      // Acima de X
      if (newProgramKPI.red_threshold_value)
        thresholdsToSend.push({
          color: "red",
          mode: "above",
          min_value: parseVal(newProgramKPI.red_threshold_value),
          max_value: null,
        });
    } else if (orientation === "MOD") {
      // Abaixo de P OU Acima de Q
      if (newProgramKPI.red_modular_below_value) {
        // P
        thresholdsToSend.push({
          color: "red",
          mode: "below",
          min_value: null,
          max_value: parseVal(newProgramKPI.red_modular_below_value),
        });
      }
      if (newProgramKPI.red_modular_above_value) {
        // Q
        thresholdsToSend.push({
          color: "red",
          mode: "above",
          min_value: parseVal(newProgramKPI.red_modular_above_value),
          max_value: null,
        });
      }
    }

    const payload = {
      action: editingProgramKPIId !== null ? "update" : "create",
      id: editingProgramKPIId,
      name: newProgramKPI.name,
      description: newProgramKPI.description,
      unit: newProgramKPI.unit,
      type: newProgramKPI.type,
      subtype: newProgramKPI.subtype,
      is_cumulative: newProgramKPI.is_cumulative,
      performance_orientation: newProgramKPI.performance_orientation,
      reporting_format: newProgramKPI.reporting_format,
      thresholds: thresholdsToSend,
    };

    try {
      const endpoint = "/api/kpis/";
      const response = await client.post(endpoint, payload);
      if (response.data.success) {
        toast.success(
          editingProgramKPIId
            ? t("program_setup.kpis.messages.update_success")
            : t("program_setup.kpis.messages.create_success")
        );
        await fetchKPIs();
        handleCloseProgramKPIDrawer();
      } else {
        const errorMessage =
          response.data.error || t("program_setup.kpis.errors.save_failed");
        console.error("Erro ao salvar KPI:", errorMessage);
        toast.error(errorMessage);
      }
    } catch (error) {
      const catchMessage = t("program_setup.kpis.errors.save_failed");
      console.error("Erro ao salvar KPI:", error);
      toast.error(catchMessage);
    } finally {
      setIsSavingKpi(false);
    }
  };

  const formatThresholdValueForInput = (value) => {
    if (value === null || value === undefined || value === "") {
      return ""; // Retorna string vazia se o valor for nulo, indefinido ou já uma string vazia
    }
    const num = parseFloat(value);
    if (isNaN(num)) {
      return ""; // Retorna string vazia se não for um número válido
    }
    // Se o número for inteiro (ou muito próximo de um), mostre sem casas decimais.
    // Caso contrário, mostre com até 2 casas decimais (ou ajuste conforme necessidade).
    // A multiplicação por 100 já foi feita antes de chamar esta função (ao carregar para edição)
    if (Number.isInteger(num)) {
      return num.toString();
    }
    // Para números com decimais, podemos usar toFixed e depois remover zeros à direita se não forem significativos
    // Ex: 12.50 -> "12.5", 12.00 -> "12" (mas já coberto pelo Number.isInteger)
    let formatted = num.toFixed(2); // Ajuste para o número de decimais desejado (ex: 2)
    // Remove .00
    if (formatted.endsWith(".00")) {
      formatted = formatted.substring(0, formatted.length - 3);
    }
    // Remove .X0 (ex: 12.50 -> 12.5)
    else if (formatted.endsWith("0") && formatted.includes(".")) {
      formatted = formatted.substring(0, formatted.length - 1);
    }
    return formatted;
  };

  // Handler to edit an existing KPI
  const handleEditProgramKPI = (kpi) => {
    setEditingProgramKPIId(kpi.id);
    const backendOrientation = kpi.performance_orientation || ""; // Nome correto do campo
    const newState = { ...initialNewProgramKPIState }; // Começa com o estado inicial limpo

    newState.name = kpi.name || "";
    newState.description = kpi.description || "";
    newState.unit = kpi.unit || "";
    newState.type = kpi.type || "program";
    newState.subtype = kpi.subtype || "";
    newState.is_cumulative =
      kpi.is_cumulative !== undefined ? kpi.is_cumulative : true;
    newState.performance_orientation = backendOrientation; // Nome correto
    newState.reporting_format = kpi.reporting_format || "initiative";

    const formatToPercentStringForEdit = (
      val // Renomeado para clareza
    ) =>
      val !== null && val !== undefined
        ? formatThresholdValueForInput(parseFloat(val) * 100) // Aplica formatação aqui
        : "";

    if (Array.isArray(kpi.thresholds)) {
      const getTh = (color, mode = null) =>
        kpi.thresholds.filter(
          (th) => th.color === color && (mode ? th.mode === mode : true)
        );

      // GREEN
      const greenData = getTh("green");
      if (greenData.length > 0) {
        const g = greenData[0];
        // Atualiza o estado 'performance_orientation' baseado no 'mode' do threshold verde
        // Isso é importante se 'performance_orientation' não vier diretamente do kpi object
        // ou se a lógica do threshold verde for a fonte da verdade para a orientação.
        // No seu caso, 'performance_orientation' já está vindo do kpi object, então esta linha abaixo pode ser redundante
        // newState.performance_orientation = g.mode === "above" ? "ASC" : g.mode === "below" ? "DESC" : "MOD";

        if (
          newState.performance_orientation === "MOD" &&
          g.mode === "between"
        ) {
          newState.green_min_value = formatToPercentStringForEdit(g.min_value);
          newState.green_max_value = formatToPercentStringForEdit(g.max_value);
        } else if (
          newState.performance_orientation === "ASC" &&
          g.mode === "above"
        ) {
          newState.green_min_value = formatToPercentStringForEdit(g.min_value);
        } else if (
          newState.performance_orientation === "DESC" &&
          g.mode === "below"
        ) {
          // Para DESC e 'below', o backend armazena em max_value
          newState.green_min_value = formatToPercentStringForEdit(g.max_value);
        }
      }

      // YELLOW - Sempre 'between'
      const yellowBetweenRanges = getTh("yellow", "between");
      if (yellowBetweenRanges.length > 0) {
        newState.yellow_min_value_1 = formatToPercentStringForEdit(
          yellowBetweenRanges[0].min_value
        );
        newState.yellow_max_value_1 = formatToPercentStringForEdit(
          yellowBetweenRanges[0].max_value
        );
        // Se for MODULAR, pode haver uma segunda faixa amarela
        if (
          newState.performance_orientation === "MOD" &&
          yellowBetweenRanges.length > 1
        ) {
          newState.yellow_min_value_2 = formatToPercentStringForEdit(
            yellowBetweenRanges[1].min_value
          );
          newState.yellow_max_value_2 = formatToPercentStringForEdit(
            yellowBetweenRanges[1].max_value
          );
        }
      }

      // RED
      if (newState.performance_orientation === "ASC") {
        // Red para ASC é "below"
        const rBelow = getTh("red", "below")[0];
        if (rBelow)
          newState.red_threshold_value = formatToPercentStringForEdit(
            rBelow.max_value // "Below X" significa que X é o max_value
          );
      } else if (newState.performance_orientation === "DESC") {
        // Red para DESC é "above"
        const rAbove = getTh("red", "above")[0];
        if (rAbove)
          newState.red_threshold_value = formatToPercentStringForEdit(
            rAbove.min_value // "Above X" significa que X é o min_value
          );
      } else if (newState.performance_orientation === "MOD") {
        // Red para MOD é "below P OR above Q"
        const rBelowMod = getTh("red", "below")[0];
        const rAboveMod = getTh("red", "above")[0];
        if (rBelowMod)
          newState.red_modular_below_value = formatToPercentStringForEdit(
            rBelowMod.max_value
          );
        if (rAboveMod)
          newState.red_modular_above_value = formatToPercentStringForEdit(
            rAboveMod.min_value
          );
      }
    }

    setNewProgramKPI(newState);
    setHasUnsavedKPIChanges(false);
    setProgramKPIDrawerOpen(true);
  };

  // Handler to delete a KPI
  const handleDeleteProgramKPI = async (kpiId) => {
    try {
      const response = await client.post("/api/kpis/", {
        action: "delete",
        id: kpiId,
      });
      const data = response.data;
      if (data.success) {
        await fetchKPIs();
      } else {
        console.error("Erro ao deletar KPI:", data);
      }
    } catch (error) {
      console.error("Erro ao deletar KPI:", error);
    }
  };

  // [CHANGED] Now that your KPI has thresholds in array format, let's adapt the function:
  const formatThresholds = (kpi) => {
    // If for some reason the API returned old structure, handle safely:
    if (!kpi.thresholds || !Array.isArray(kpi.thresholds)) {
      return "-";
    }

    // Example: Build a string for each color -> "green(above): >50", "yellow(between): 20-50", ...
    return kpi.thresholds
      .map((th) => {
        const { color, mode, min_value, max_value } = th;
        let range = "";
        if (mode === "between") {
          range = `${min_value ?? 0} - ${max_value ?? ""}`;
        } else if (mode === "above") {
          range = `>${min_value ?? ""}`;
        } else if (mode === "below") {
          range = `<${max_value ?? ""}`;
        }
        return `${color} (${mode}): ${range}`;
      })
      .join(" | ");
  };
  // Function to load backend impacts

  useEffect(() => {
    fetchImpacts();
  }, []);

  const fetchImpacts = async () => {
    setIsLoadingImpacts(true);
    try {
      const response = await client.post("/api/impacts/", { action: "list" });
      const data = response.data;
      if (data.success && Array.isArray(data.impacts)) {
        setImpacts(data.impacts);
      } else {
        console.error("Erro ao carregar Impactos");
        setImpacts([]);
      }
    } catch (error) {
      console.error("Erro ao buscar Impactos:", error);
      setImpacts([]);
    } finally {
      setIsLoadingImpacts(false);
    }
  };

  const handleOpenImpactDrawer = () => {
    setEditingImpactId(null); // Cleans any previous edition

    setNewImpact({
      impact: "",
      description: "",
    });
    setImpactDrawerOpen(true);
    setHasUnsavedImpactChanges(false);
  };

  const handleCloseImpactDrawer = () => {
    setHasUnsavedImpactChanges(false);
    setImpactDrawerOpen(false);
    setEditingImpactId(null);
    setNewImpact({ impact: "", description: "" });
  };

  const handleImpactChange = (e) => {
    setNewImpact({
      ...newImpact,
      [e.target.name]: e.target.value,
    });
    if (editingImpactId !== null) {
      setHasUnsavedImpactChanges(true);
    }
  };

  // Location IF New

  useEffect(() => {
    if (impactDrawerOpen && editingImpactId === null) {
      const stored = localStorage.getItem("draftImpact");
      if (stored) {
        setNewImpact(JSON.parse(stored));
      }
    }
  }, [impactDrawerOpen, editingImpactId]);

  useEffect(() => {
    if (impactDrawerOpen && editingImpactId === null) {
      localStorage.setItem("draftImpact", JSON.stringify(newImpact));
    }
  }, [impactDrawerOpen, editingImpactId, newImpact]);

  const handleSaveImpact = async () => {
    const action = editingImpactId !== null ? "update" : "create";
    const payload = {
      action,
      id: editingImpactId,
      impact: newImpact.impact,
      description: newImpact.description,
    };

    try {
      const response = await client.post("/api/impacts/", payload);
      const data = response.data;
      if (data.success) {
        await fetchImpacts();
        if (editingImpactId === null) {
          localStorage.removeItem("draftImpact");
        }
        handleCloseImpactDrawer();
      } else {
        console.error("Erro ao salvar Impact:", data);
      }
    } catch (error) {
      console.error("Erro ao salvar Impact:", error);
    }
  };

  const handleEditImpact = (impact) => {
    setEditingImpactId(impact.id);
    setNewImpact({
      impact: impact.impact,
      description: impact.description,
    });
    setImpactDrawerOpen(true);
  };

  const handleDeleteImpact = async (impactId) => {
    try {
      const response = await client.post("/api/impacts/", {
        action: "delete",
        id: impactId,
      });
      const data = response.data;
      if (data.success) {
        await fetchImpacts();
      } else {
        console.error("Erro ao deletar Impact:", data);
      }
    } catch (error) {
      console.error("Erro ao deletar Impact:", error);
    }
  };

  // **ADDED: States for EXCLUSION CONFIRMATION **

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState({
    type: "", // Tipo do item: 'branch', 'workfront', 'approvalLevel', 'kpi', 'impact', 'user', 'accessGroup'
    id: null, // ID of item to be deleted
    name: "", // Item name (for display in the message)
  });

  // Handler to open delete's dialogue

  const handleOpenDeleteDialog = (type, id, name) => {
    setDeleteTarget({ type, id, name });
    setDeleteDialogOpen(true);
  };

  // Handler to close Delete's dialogue

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setDeleteTarget({ type: "", id: null, name: "" });
  };

  // Handler to confirm the exclusion

  const handleConfirmDelete = () => {
    const { type, id } = deleteTarget;

    switch (type) {
      case "branch":
        handleDeleteBranch(id);
        break;
      case "workfront":
        handleDeleteWorkfront(id);
        break;
      case "approvalLevel":
        handleDeleteApprovalLevel(id);
        break;
      case "kpi":
        handleDeleteProgramKPI(id);
        break;
      case "impact":
        handleDeleteImpact(id);
        break;
      case "user":
        handleDeleteSystemUser(id);
        break;
      case "accessGroup":
        handleDeleteAccessGroup(id);
        break;
      // 🔽 ADD THIS MISSING CASE FOR 'role' 🔽
      case "role":
        handleDeleteRole(id);
        break;
      default:
        // It's good practice to log if an unknown type is encountered
        console.warn("handleConfirmDelete called with unknown type:", type);
        break;
    }

    handleCloseDeleteDialog();
  };
  // Function to sort the data

  const sortData = (data, config) => {
    if (!config.key) return data;
    const sortedData = [...data].sort((a, b) => {
      const aValue = (a[config.key]?.toString() ?? "").toLowerCase();
      const bValue = (b[config.key]?.toString() ?? "").toLowerCase();
      if (aValue < bValue) {
        return config.direction === "ascending" ? -1 : 1;
      }
      if (aValue > bValue) {
        return config.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
    return sortedData;
  };

  // **ADDED: SERVICE STATES FOR USERS AND ACCESS GROUPS **

  const [sortConfigUsers, setSortConfigUsers] = useState({
    key: null,
    direction: null,
  });

  const [sortConfigAccessGroups, setSortConfigAccessGroups] = useState({
    key: null,
    direction: null,
  });

  // Ordination functions for users and access groups

  const handleSortUsers = (key) => {
    let direction = "ascending";
    if (
      sortConfigUsers.key === key &&
      sortConfigUsers.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfigUsers({ key, direction });
  };

  const handleSortAccessGroups = (key) => {
    let direction = "ascending";
    if (
      sortConfigAccessGroups.key === key &&
      sortConfigAccessGroups.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfigAccessGroups({ key, direction });
  };

  // Ordination functions for each table

  const handleSortBranches = (key) => {
    let direction = "ascending";
    if (
      sortConfigBranches.key === key &&
      sortConfigBranches.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfigBranches({ key, direction });
  };
  const handleSortWorkfronts = (key) => {
    let direction = "ascending";
    if (
      sortConfigWorkfronts.key === key &&
      sortConfigWorkfronts.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfigWorkfronts({ key, direction });
  };
  const handleSortApprovalLevels = (key) => {
    let direction = "ascending";
    if (
      sortConfigApprovalLevels.key === key &&
      sortConfigApprovalLevels.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfigApprovalLevels({ key, direction });
  };
  const handleSortProgramKPIs = (key) => {
    let direction = "ascending";
    if (
      sortConfigProgramKPIs.key === key &&
      sortConfigProgramKPIs.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfigProgramKPIs({ key, direction });
  };
  // **ADDED: Handle Sort for Impacts **

  const handleSortImpacts = (key) => {
    let direction = "ascending";
    if (
      sortConfigImpacts.key === key &&
      sortConfigImpacts.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfigImpacts({ key, direction });
  };



  // ----------------------------------------------------------
  // Additional Block: Users and Access groups
  // ----------------------------------------------------------

  const [userTabValue, setUserTabValue] = useState(0);
  const handleUserTabChange = (event, newValue) => {
    setUserTabValue(newValue);
  };

  // **ADDED: States for filters on users and access groups **
  // States for filters on the Users tab

  const [userFilter, setUserFilter] = useState("");

  const handleUserFilterChange = (value) => {
    setUserFilter(value.toLowerCase());
  };

  // States for filters on the Access Groups tab

  const [accessGroupFilterGroupName, setAccessGroupFilterGroupName] =
    useState("");

  // Handlers for Users

  // States for system users

  const [systemUsers, setSystemUsers] = useState([]);
  const [newSystemUser, setNewSystemUser] = useState({
    first_name: "",
    last_name: "",
    email: "",
  });
  const [editingSystemUserId, setEditingSystemUserId] = useState(null);
  const [userDrawerOpen, setUserDrawerOpen] = useState(false);
  const [hasUnsavedUserChanges, setHasUnsavedUserChanges] = useState(false);

  // UseeFect to load users and access groups when setting up the component

  useEffect(() => {
    fetchSystemUsers(); // Reuse the existing function

    fetchAccessGroups();
  }, []);

  // Function to search for Backend users

  const fetchSystemUsers = async () => {
    setisLoadingUsers(true);
    try {
      // This endpoint now returns both users and available roles
      const response = await client.post("/api/user_management/", {
        action: "list",
      });
      const data = response.data;
      if (data.success) {
        setSystemUsers(data.users || []); // Your existing state for users
        // You already have a 'roles' state, we can reuse it, but let's be explicit
        // Assuming the roles from this endpoint are for the dropdown.
        // The 'fetchRoles' already populates the main roles state.
        // Let's create a new state for the dropdown if needed, or check if they are the same.
        // For simplicity, we assume fetchRoles() is the source of truth for all roles.
      } else {
        toast.error("Failed to fetch users.");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      toast.error("Error fetching users.");
    } finally {
      setisLoadingUsers(false);
    }
  };
  useEffect(() => {}, [systemUsers]);

  // Function to open the user drawer

  const handleOpenUserDrawer = () => {
    setEditingSystemUserId(null);
    // Reset state for new user, including role_id
    setNewSystemUser({ first_name: "", last_name: "", email: "", role_id: "" });
    setUserDrawerOpen(true);
    setHasUnsavedUserChanges(false);
  };

  // Function to close the user drawer

  const handleCloseUserDrawer = () => {
    setHasUnsavedUserChanges(false);
    setUserDrawerOpen(false);
    setEditingSystemUserId(null);
    setNewSystemUser({ first_name: "", last_name: "", email: "" });
  };

  // Function to deal with changes in the user form

  const handleSystemUserChange = (e) => {
    setNewSystemUser({
      ...newSystemUser,
      [e.target.name]: e.target.value,
    });
    if (editingSystemUserId !== null) {
      setHasUnsavedUserChanges(true);
    }
  };
  // LocalStorage for new user

  useEffect(() => {
    if (userDrawerOpen && editingSystemUserId === null) {
      const stored = localStorage.getItem("draftSystemUser");
      if (stored) {
        setNewSystemUser(JSON.parse(stored));
      }
    }
  }, [userDrawerOpen, editingSystemUserId]);

  useEffect(() => {
    if (userDrawerOpen && editingSystemUserId === null) {
      localStorage.setItem("draftSystemUser", JSON.stringify(newSystemUser));
    }
  }, [userDrawerOpen, editingSystemUserId, newSystemUser]);

  // Function to save (create or edit) a user

  const handleSaveSystemUser = async () => {
    if (!newSystemUser.email) {
      toast.error(t("program_setup.users.errors.email_required"));
      return;
    }

    const payload = {
      action: editingSystemUserId ? "update" : "create",
      id: editingSystemUserId,
      first_name: newSystemUser.first_name,
      last_name: newSystemUser.last_name,
      email: newSystemUser.email,
      role_id: newSystemUser.role_id, // ⭐️ Pass the role_id
    };

    try {
      await client.post("/api/users/", payload);
      toast.success(
        editingSystemUserId
          ? t("program_setup.users.messages.update_success")
          : t("program_setup.users.messages.create_success")
      );
      await fetchSystemUsers();
      handleCloseUserDrawer();
    } catch (error) {
      console.error("Error saving user:", error);
      toast.error(
        error.response?.data?.error ||
          t("program_setup.users.errors.save_failed")
      );
    }
  };

  // Function to edit an existing user

  const handleEditSystemUser = (user) => {
    setEditingSystemUserId(user.id);
    const nameParts = user.name.split(" ");
    setNewSystemUser({
      first_name: nameParts[0] || "",
      last_name: nameParts.slice(1).join(" ") || "",
      email: user.email,
      role_id: user.role_id || "", // ⭐️ Set the role_id for editing
    });
    setUserDrawerOpen(true);
  };

  // Function to delete a user

  const handleDeleteSystemUser = async (userId) => {
    try {
      const response = await client.post("/api/users/", {
        action: "delete",
        id: userId,
      });
      const data = response.data;
      if (data.success) {
        const updatedUsers = systemUsers.filter((u) => u.id !== userId);
        setSystemUsers(updatedUsers);
        // Remove this user also from the groups, if necessary:

        const updatedGroups = accessGroups.map((g) => ({
          ...g,
          users: g.users.filter((uid) => uid !== userId),
        }));
        setAccessGroups(updatedGroups);
        toast.success("Usuário deletado com sucesso!");
      } else {
        console.error("Erro ao deletar usuário:", data.error);
        toast.error(`Erro ao deletar usuário: ${data.error}`);
      }
    } catch (error) {
      console.error("Erro ao deletar usuário:", error);
      toast.error("Erro ao deletar usuário.");
    }
  };

  // States for Access Groups

  const [accessGroups, setAccessGroups] = useState([]);
  const [newAccessGroup, setNewAccessGroup] = useState({
    groupName: "",
    users: [],
  });
  const [editingAccessGroupId, setEditingAccessGroupId] = useState(null);
  const [accessGroupDrawerOpen, setAccessGroupDrawerOpen] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isLoadingAccessGroups, setIsLoadingAccessGroups] = useState(false);
  const [hasUnsavedAccessGroupChanges, setHasUnsavedAccessGroupChanges] =
    useState(false);

  // Loads Access Groups when setting up the component

  useEffect(() => {
    fetchAccessGroups();
  }, []);

  const fetchAccessGroups = async () => {
    setIsLoadingAccessGroups(true);
    try {
      const response = await client.post("/api/access_groups/", {
        action: "list",
      });
      const data = response.data;
      if (data.success && Array.isArray(data.accessGroups)) {
        setAccessGroups(
          data.accessGroups.map((group) => ({
            id: group.id,
            groupName: group.groupName,
            users: group.users, // <-- Keep the full user object array
          }))
        );
      } else {
        console.error("Erro ao carregar access groups");
        setAccessGroups([]);
      }
    } catch (error) {
      console.error("Erro ao buscar access groups:", error);
      setAccessGroups([]);
    } finally {
      setIsLoadingAccessGroups(false);
    }
  };

  const handleOpenAccessGroupDrawer = () => {
    setEditingAccessGroupId(null);
    setNewAccessGroup({ groupName: "", users: [] });
    setAccessGroupDrawerOpen(true);
    setHasUnsavedAccessGroupChanges(false);
  };

  const handleCloseAccessGroupDrawer = () => {
    setHasUnsavedAccessGroupChanges(false);
    setAccessGroupDrawerOpen(false);
    setEditingAccessGroupId(null);
    setNewAccessGroup({ groupName: "", users: [] });
  };

  const handleAccessGroupChange = (e) => {
    setNewAccessGroup({
      ...newAccessGroup,
      [e.target.name]: e.target.value,
    });
    if (editingAccessGroupId !== null) {
      setHasUnsavedAccessGroupChanges(true);
    }
  };

  // Place storage

  useEffect(() => {
    if (accessGroupDrawerOpen && editingAccessGroupId === null) {
      const stored = localStorage.getItem("draftAccessGroup");
      if (stored) {
        setNewAccessGroup(JSON.parse(stored));
      }
    }
  }, [accessGroupDrawerOpen, editingAccessGroupId]);

  useEffect(() => {
    if (accessGroupDrawerOpen && editingAccessGroupId === null) {
      localStorage.setItem("draftAccessGroup", JSON.stringify(newAccessGroup));
    }
  }, [accessGroupDrawerOpen, editingAccessGroupId, newAccessGroup]);

  const handleSaveAccessGroup = async () => {
    const action = editingAccessGroupId !== null ? "update" : "create";
    const payload = {
      action,
      id: editingAccessGroupId,
      groupName: newAccessGroup.groupName,
      users: newAccessGroup.users, // User IDS Array
    };

    try {
      const response = await client.post("/api/access_groups/", payload);
      const data = response.data;
      if (data.success) {
        // Recharge the Backend list

        await fetchAccessGroups();
        if (editingAccessGroupId === null) {
          localStorage.removeItem("draftAccessGroup");
        }
        handleCloseAccessGroupDrawer();
      } else {
        console.error("Erro ao salvar grupo de acesso:", data);
      }
    } catch (error) {
      console.error("Erro ao salvar grupo de acesso:", error);
    }
  };

  const handleEditAccessGroup = (group) => {
    setEditingAccessGroupId(group.id);
    setNewAccessGroup({
      groupName: group.groupName,
      users: group.users.map((user) => user.id),
    });
    setAccessGroupDrawerOpen(true);
  };

  const handleDeleteAccessGroup = async (groupId) => {
    try {
      const response = await client.post("/api/access_groups/", {
        action: "delete",
        id: groupId,
      });
      const data = response.data;
      if (data.success) {
        // Recharge the Backend list

        await fetchAccessGroups();
      } else {
        console.error("Erro ao deletar grupo de acesso:", data);
      }
    } catch (error) {
      console.error("Erro ao deletar grupo de acesso:", error);
    }
  };

  // -----------New Block for Role Management-------------

  // START: NEW STATES FOR ROLE MANAGEMENT
  const [roles, setRoles] = useState([]);
  const [isLoadingRoles, setIsLoadingRoles] = useState(false);
  const [roleChanges, setRoleChanges] = useState({}); // To track modified roles { roleId: { permission: value } }
  const [isSavingRoles, setIsSavingRoles] = useState(false);

  const [roleDrawerOpen, setRoleDrawerOpen] = useState(false);
  const [editingRoleId, setEditingRoleId] = useState(null);
  const [newRole, setNewRole] = useState({ name: "", description: "" });
  const [hasUnsavedRoleChanges, setHasUnsavedRoleChanges] = useState(false);

  // END: NEW STATES FOR ROLE MANAGEMENT

  // ... (suas funções de fetch existentes, como fetchBranches, etc.)

  // START: NEW FUNCTIONS FOR ROLE MANAGEMENT
  const fetchRoles = async () => {
    setIsLoadingRoles(true);
    try {
      const response = await client.post("/api/role-management/", {
        action: "list",
      });
      if (response.data.success) {
        setRoles(response.data.roles);
        // Populate the state with the metadata (list of keys) from the backend
        setPermissionMetadata(response.data.permissions_metadata || []);
      } else {
        toast.error(t("program_setup.roles.errors.load_failed"));
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error(t("program_setup.roles.errors.load_failed"));
    } finally {
      setIsLoadingRoles(false);
    }
  };

  // Fetch roles on component mount
  useEffect(() => {
    fetchRoles();
  }, []);

  const handlePermissionChange = (roleId, permissionKey, isChecked) => {
    setRoleChanges((prev) => ({
      ...prev,
      [roleId]: {
        ...prev[roleId],
        [permissionKey]: isChecked,
      },
    }));
  };

  const handleSaveRoleChanges = async () => {
    setIsSavingRoles(true);
    const promises = Object.keys(roleChanges).map((roleId) => {
      const role = roles.find((r) => r.id === parseInt(roleId));
      const payload = {
        action: "update",
        id: parseInt(roleId),
        permissions: roleChanges[roleId],
        // Pass current name and description to prevent them from being cleared
        name: role.name,
        description: role.description,
      };
      return client.post("/api/role-management/", payload);
    });

    try {
      await Promise.all(promises);
      toast.success(t("program_setup.roles.messages.save_success"));
      setRoleChanges({}); // Reset changes
      await fetchRoles(); // Refetch to get the latest state
    } catch (error) {
      console.error("Error saving role changes:", error);
      toast.error(t("program_setup.roles.errors.save_failed"));
    } finally {
      setIsSavingRoles(false);
    }
  };

  // START: NEW STATES AND FUNCTIONS FOR USER ROLE ASSIGNMENT
  const [modifiedUserRoles, setModifiedUserRoles] = useState({}); // { userId: newRoleId }
  const [isSavingUserRoles, setIsSavingUserRoles] = useState(false);

  const handleUserRoleChange = (userId, newRoleId) => {
    setModifiedUserRoles((prev) => ({
      ...prev,
      [userId]: newRoleId,
    }));
  };

  const handleSaveUserRoles = async () => {
    setIsSavingUserRoles(true);
    try {
      const payload = {
        modifiedRoles: modifiedUserRoles,
      };
      const response = await client.post(
        "/api/user_management_save_roles/",
        payload
      );
      if (response.data.success) {
        toast.success(t("program_setup.users.messages.roles_updated"));
        setModifiedUserRoles({}); // Reset changes
        await fetchSystemUsers(); // Refetch users to show updated roles
      } else {
        toast.error(t("program_setup.users.errors.update_failed"));
      }
    } catch (error) {
      console.error("Error saving user roles:", error);
      toast.error(t("program_setup.users.errors.update_failed"));
    } finally {
      setIsSavingUserRoles(false);
    }
  };

  const [managementTabValue, setManagementTabValue] = useState(0);
  const handleManagementTabChange = (event, newValue) => {
    setManagementTabValue(newValue);
  };

  const handleOpenRoleDrawer = (role = null) => {
    if (role) {
      setEditingRoleId(role.id);
      setNewRole({ name: role.name, description: role.description });
    } else {
      setEditingRoleId(null);
      setNewRole({ name: "", description: "" });
    }
    setRoleDrawerOpen(true);
    setHasUnsavedRoleChanges(false);
  };

  const handleCloseRoleDrawer = () => {
    setRoleDrawerOpen(false);
    setEditingRoleId(null);
    setNewRole({ name: "", description: "" });
    setHasUnsavedRoleChanges(false);
  };

  const handleRoleFormChange = (e) => {
    setNewRole((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setHasUnsavedRoleChanges(true);
  };

  const handleSaveRole = async () => {
    if (!newRole.name) {
      toast.error(t("program_setup.roles.errors.name_required"));
      return;
    }

    const payload = {
      action: editingRoleId ? "update" : "create",
      id: editingRoleId,
      name: newRole.name,
      description: newRole.description,
    };

    // When updating, we must also send the existing permissions to avoid clearing them
    if (editingRoleId) {
      const currentRole = roles.find((r) => r.id === editingRoleId);
      const permissions = {};
      Object.keys(currentRole).forEach((key) => {
        if (typeof currentRole[key] === "boolean" && key !== "is_default") {
          permissions[key] = currentRole[key];
        }
      });
      payload.permissions = permissions;
    }

    try {
      await client.post("/api/role-management/", payload);
      toast.success(
        editingRoleId
          ? t("program_setup.roles.messages.update_success")
          : t("program_setup.roles.messages.create_success")
      );
      await fetchRoles();
      handleCloseRoleDrawer();
    } catch (error) {
      console.error("Error saving role:", error);
      toast.error(t("program_setup.roles.errors.save_failed"));
    }
  };

  const handleDeleteRole = async (roleId) => {
    try {
      await client.post("/api/role-management/", {
        action: "delete",
        id: roleId,
      });
      toast.success(t("program_setup.roles.messages.delete_success"));
      fetchRoles(); // Refresh the list
    } catch (error) {
      console.error("Error deleting role:", error);
      const errorMsg =
        error.response?.data?.error ||
        t("program_setup.roles.errors.delete_failed");
      toast.error(errorMsg);
    }
  };

  const [permissionMetadata, setPermissionMetadata] = useState([]);

  // Functions to save changes
  const [hasChanges, setHasChanges] = useState(false);
  const [isSavingAllChanges, setIsSavingAllChanges] = useState(false);

  useEffect(() => {
    const rolesChanged = Object.keys(roleChanges).length > 0;
    const userRolesChanged = Object.keys(modifiedUserRoles).length > 0;
    setHasChanges(rolesChanged || userRolesChanged);
  }, [roleChanges, modifiedUserRoles]);

  const handleSaveAllChanges = async () => {
    setIsSavingAllChanges(true); // 1. Start loading state

    const savePromises = [];

    // Build the array of save promises (this logic remains the same)
    if (Object.keys(roleChanges).length > 0) {
      const roleSavePromises = Object.keys(roleChanges).map((roleId) => {
        const role = roles.find((r) => r.id === parseInt(roleId));
        const payload = {
          action: "update",
          id: parseInt(roleId),
          permissions: roleChanges[roleId],
          name: role.name,
          description: role.description,
        };
        return client.post("/api/role-management/", payload);
      });
      savePromises.push(...roleSavePromises);
    }

    if (Object.keys(modifiedUserRoles).length > 0) {
      const userRoleSavePromise = client.post(
        "/api/user_management_save_roles/",
        { modifiedRoles: modifiedUserRoles }
      );
      savePromises.push(userRoleSavePromise);
    }

    try {
      // 2. Await ONLY the save operations
      await Promise.all(savePromises);

      // 3. Save was successful, so immediately give feedback and stop loading
      toast.success(
        t(
          "program_setup.roles.messages.save_success",
          "Changes saved successfully!"
        )
      );
      setIsSavingAllChanges(false); // <-- FIX: Stop loading state HERE

      // 4. Reset the local change-tracking states
      setRoleChanges({});
      setModifiedUserRoles({});

      // 5. Refetch data in the background to update the view
      // The user already sees the loading has finished, which is a better UX.
      fetchRoles();
      fetchSystemUsers();
    } catch (error) {
      // If any save promise fails...
      console.error("Error saving changes:", error);
      toast.error(
        t("program_setup.roles.errors.save_failed", "Error saving changes")
      );
      setIsSavingAllChanges(false); // <-- FIX: Also stop loading state on error
    }
    // The 'finally' block is no longer needed as we handle state in both try and catch
  };

  console.log(userDetails);
  return (
    <div className={classes.drawerContent}>
      {/* Accordion 1: Current component (program records) */}

      <Accordion className={classes.accordionRootCustom} defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          style={{ display: "flex", alignItems: "middle" }}
        >
          <CardHeader
            color="client"
            icon
            style={{
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <CardIcon color="client">
              <Settings />
            </CardIcon>
            <h4
              className={classes.cardIconTitle}
              style={{ marginBottom: 0, whiteSpace: "nowrap" }}
            >
              {t("program_setup.title")}
            </h4>
          </CardHeader>
        </AccordionSummary>
        <AccordionDetails style={{ display: "block" }}>
          {/* Card body */}
          <AppBar position="static" color="default" elevation={0}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              classes={{
                root: classes.tabsRoot,
                indicator: classes.indicator,
              }}
              variant="fullWidth"
              aria-label="Program Setup Tabs"
            >
              <Tab label={t("program_setup.tabs.branchs")} {...a11yProps(0)} />
              <Tab
                label={t("program_setup.tabs.workfronts")}
                {...a11yProps(1)}
              />
              {/*
              <Tab
                label={t("program_setup.tabs.approval_flow")}
                {...a11yProps(2)}
              />
              */}
              <Tab label={t("program_setup.tabs.kpis")} {...a11yProps(3)} />
              <Tab
                label={t("program_setup.tabs.impacts")}
                {...a11yProps(4)}
              />{" "}
              {/* New tab */}
            </Tabs>
          </AppBar>
          {/* Tab panels */}
          <TabPanel value={tabValue} index={0}>
            {/* BRANCHES ABA CONTENTS */}
            {/* **ADDED: BRANCHS FILTERS (Optional) */}
            {/* If you want to add filters to branches, you can follow the same pattern */}
            <GridContainer justifyContent="flex-end">
              <GridItem>
                <Button
                  color="client"
                  className={classes.cardButton}
                  onClick={handleOpenBranchDrawer}
                  disabled={false}
                  size="sm" // Keeping the size according to its original code
                >
                  <AddCircle className={classes.cardButtonIcon} />
                </Button>
              </GridItem>
            </GridContainer>
            {/* Brancheis table */}
            <Table>
              <TableHead>
                <TableRow>
                  {/* "Branch Name" column with ordering icons */}
                  <TableCell
                    className={classes.tableHeadCell}
                    onClick={() => handleSortBranches("name")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>{t("program_setup.table_head.branch_name")}</span>
                      <FontAwesomeIcon
                        icon={
                          sortConfigBranches.key === "name"
                            ? sortConfigBranches.direction === "ascending"
                              ? faSortUp
                              : faSortDown
                            : faSort
                        }
                        className={
                          sortConfigBranches.key === "name"
                            ? `${classes.sortIcon} ${classes.activeSortIcon}`
                            : classes.sortIcon
                        }
                      />
                    </div>
                  </TableCell>

                  {/* "Branch leader" column with sorting icons */}
                  <TableCell
                    className={classes.tableHeadCell}
                    onClick={() => handleSortBranches("leaderName")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>{t("program_setup.table_head.branch_leader")}</span>
                      <FontAwesomeIcon
                        icon={
                          sortConfigBranches.key === "leaderName"
                            ? sortConfigBranches.direction === "ascending"
                              ? faSortUp
                              : faSortDown
                            : faSort
                        }
                        className={
                          sortConfigBranches.key === "leaderName"
                            ? `${classes.sortIcon} ${classes.activeSortIcon}`
                            : classes.sortIcon
                        }
                      />
                    </div>
                  </TableCell>

                  <TableCell
                    className={classes.tableHeadCell}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>
                        {t("program_setup.table_head.branch_description")}
                      </span>
                    </div>
                  </TableCell>

                  {/* "Actions" column without ordering icons */}
                  <TableCell
                    className={classes.tableHeadCell}
                    align="center" // Centralize the content
                    style={{ cursor: "default" }}
                  >
                    <span>{t("program_setup.table_head.actions")}</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortData(branches, sortConfigBranches).map((branch) => (
                  <TableRow key={branch.id}>
                    {/* "BRANCH NAME" column */}
                    <TableCell>{branch.name}</TableCell>
                    {/* "Branch Leader" column */}
                    <TableCell>{branch.leaderName}</TableCell>{" "}
                    <TableCell>{branch.description}</TableCell>{" "}
                    {/* Adjustment according to the actual data */}
                    {/* "Actions" column */}
                    <TableCell align="center">
                      <div className={classes.actionIconsCustom}>
                        <Tooltip title={t("program_setup.actions.edit")} arrow>
                          <EditIcon
                            className={classes.iconButtonCustom}
                            onClick={() => handleEditBranch(branch)}
                            size="small" // Keeping the size according to its original code
                          />
                        </Tooltip>
                        <Tooltip
                          title={t("program_setup.actions.delete")}
                          arrow
                        >
                          <DeleteIcon
                            className={classes.iconButtonCustom}
                            onClick={() =>
                              handleOpenDeleteDialog(
                                "branch",
                                branch.id,
                                branch.name
                              )
                            }
                            size="small" // Keeping the size according to its original code
                          />
                        </Tooltip>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            {/* Workfronts tab contents */}
            {/* Workfronts tab header with title, branch filter and add button */}
            <GridContainer
              justifyContent="space-between"
              alignItems="center" // Central vertical alignment
            >
              {/* Gridim for the filter */}
              <GridItem xs={12} sm={6}>
                <div
                  style={{
                    padding: "0 0px 0px 0px",
                    display: "flex",
                    alignItems: "center", // Vertically align the items within this div
                  }}
                >
                  <FontAwesomeIcon
                    icon={faFilter}
                    style={{
                      marginRight: "16px",
                      fontSize: "20px",
                      color: "#666",
                    }}
                  />
                  {/* Branch */}
                  <FormControl
                    className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                  >
                    <Select
                      displayEmpty
                      classes={{
                        select: `${classes.select} ${classes.selectFormControlOverride}`,
                      }}
                      value={workfrontFilterBranch}
                      onChange={(e) => setWorkfrontFilterBranch(e.target.value)}
                    >
                      <MenuItem
                        value=""
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        {t("program_setup.filters.all_branches")}
                      </MenuItem>
                      {branches.map((branch) => (
                        <MenuItem
                          key={branch.id}
                          value={branch.name}
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                        >
                          {branch.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </GridItem>

              {/* Gridm for the Add button */}
              <GridItem
                xs={12}
                sm={6}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  color="client"
                  className={classes.cardButton}
                  onClick={handleOpenWorkfrontDrawer}
                  disabled={false}
                  size="sm"
                >
                  <AddCircle className={classes.cardButtonIcon} />
                </Button>
              </GridItem>
            </GridContainer>
            {/* Workfronts Table */}
            <Table style={{ marginTop: "0px" }}>
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.tableHeadCell}
                    onClick={() => handleSortWorkfronts("name")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>
                        {t("program_setup.table_head.workfront_name")}
                      </span>
                      <FontAwesomeIcon
                        icon={
                          sortConfigWorkfronts.key === "name"
                            ? sortConfigWorkfronts.direction === "ascending"
                              ? faSortUp
                              : faSortDown
                            : faSort
                        }
                        className={
                          sortConfigWorkfronts.key === "name"
                            ? `${classes.sortIcon} ${classes.activeSortIcon}`
                            : classes.sortIcon
                        }
                      />
                    </div>
                  </TableCell>

                  <TableCell
                    className={classes.tableHeadCell}
                    onClick={() => handleSortWorkfronts("leader")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>
                        {t("program_setup.table_head.workfront_leader")}
                      </span>
                      <FontAwesomeIcon
                        icon={
                          sortConfigWorkfronts.key === "leader"
                            ? sortConfigWorkfronts.direction === "ascending"
                              ? faSortUp
                              : faSortDown
                            : faSort
                        }
                        className={
                          sortConfigWorkfronts.key === "leader"
                            ? `${classes.sortIcon} ${classes.activeSortIcon}`
                            : classes.sortIcon
                        }
                      />
                    </div>
                  </TableCell>

                  <TableCell
                    className={classes.tableHeadCell}
                    onClick={() => handleSortWorkfronts("branch")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>{t("program_setup.table_head.branch")}</span>
                      <FontAwesomeIcon
                        icon={
                          sortConfigWorkfronts.key === "branch"
                            ? sortConfigWorkfronts.direction === "ascending"
                              ? faSortUp
                              : faSortDown
                            : faSort
                        }
                        className={
                          sortConfigWorkfronts.key === "branch"
                            ? `${classes.sortIcon} ${classes.activeSortIcon}`
                            : classes.sortIcon
                        }
                      />
                    </div>
                  </TableCell>

                  <TableCell
                    className={classes.tableHeadCell}
                    onClick={() => handleSortWorkfronts("startDate")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>{t("program_setup.table_head.start_date")}</span>
                      <FontAwesomeIcon
                        icon={
                          sortConfigWorkfronts.key === "startDate"
                            ? sortConfigWorkfronts.direction === "ascending"
                              ? faSortUp
                              : faSortDown
                            : faSort
                        }
                        className={
                          sortConfigWorkfronts.key === "startDate"
                            ? `${classes.sortIcon} ${classes.activeSortIcon}`
                            : classes.sortIcon
                        }
                      />
                    </div>
                  </TableCell>

                  <TableCell
                    className={classes.tableHeadCell}
                    onClick={() => handleSortWorkfronts("endDate")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>{t("program_setup.table_head.end_date")}</span>
                      <FontAwesomeIcon
                        icon={
                          sortConfigWorkfronts.key === "endDate"
                            ? sortConfigWorkfronts.direction === "ascending"
                              ? faSortUp
                              : faSortDown
                            : faSort
                        }
                        className={
                          sortConfigWorkfronts.key === "endDate"
                            ? `${classes.sortIcon} ${classes.activeSortIcon}`
                            : classes.sortIcon
                        }
                      />
                    </div>
                  </TableCell>

                  <TableCell className={classes.tableHeadCell} align="center">
                    {t("program_setup.table_head.actions")}
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {sortData(
                  workfrontFilterBranch
                    ? workfronts.filter(
                        (workfront) =>
                          workfront.branch === workfrontFilterBranch
                      )
                    : workfronts,
                  sortConfigWorkfronts
                ).map((workfront) => (
                  <TableRow key={workfront.id}>
                    <TableCell>{workfront.name}</TableCell>
                    <TableCell>{workfront.leader}</TableCell>
                    <TableCell>{workfront.branch}</TableCell>
                    <TableCell>{workfront.startDate}</TableCell>
                    <TableCell>{workfront.endDate}</TableCell>
                    <TableCell align="center">
                      <div className={classes.actionIconsCustom}>
                        <Tooltip title={t("program_setup.actions.edit")} arrow>
                          <EditIcon
                            className={classes.iconButtonCustom}
                            onClick={() => handleEditWorkfront(workfront)}
                            size="sm"
                          />
                        </Tooltip>
                        <Tooltip
                          title={t("program_setup.actions.delete")}
                          arrow
                        >
                          <DeleteIcon
                            className={classes.iconButtonCustom}
                            onClick={() =>
                              handleOpenDeleteDialog(
                                "workfront",
                                workfront.id,
                                workfront.name
                              )
                            }
                            size="sm"
                          />
                        </Tooltip>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TabPanel>
          {/* Block 1: Registration of approval levels 
          <TabPanel value={tabValue} index={2}>
            
            <GridContainer
              justifyContent="space-between"
              alignItems="center"
              style={{ marginBottom: "20px" }}
            >
              <GridItem>
                <Typography variant="h6">
                  {t("program_setup.approval_flow.manage_levels")}
                </Typography>
              </GridItem>
              <GridItem>
                <Button
                  color="client"
                  className={classes.cardButton}
                  onClick={handleOpenApprovalDrawer}
                  disabled={false}
                  size="sm" // Keeping the size according to its original code
                >
                  <AddCircle className={classes.cardButtonIcon} />
                </Button>
              </GridItem>
            </GridContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.tableHeadCell}
                    onClick={() => handleSortApprovalLevels("name")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>{t("program_setup.table_head.level_name")}</span>
                      <FontAwesomeIcon
                        icon={
                          sortConfigApprovalLevels.key === "name"
                            ? sortConfigApprovalLevels.direction === "ascending"
                              ? faSortUp
                              : faSortDown
                            : faSort
                        }
                        className={
                          sortConfigApprovalLevels.key === "name"
                            ? `${classes.sortIcon} ${classes.activeSortIcon}`
                            : classes.sortIcon
                        }
                      />
                    </div>
                  </TableCell>
                  <TableCell className={classes.tableHeadCell} align="center">
                    {t("program_setup.table_head.actions")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortData(approvalLevels, sortConfigApprovalLevels).map(
                  (level) => (
                    <TableRow key={level.id}>
                      <TableCell>{level.name}</TableCell>
                      <TableCell align="center">
                        <div className={classes.actionIconsCustom}>
                          <Tooltip
                            title={t("program_setup.actions.edit")}
                            arrow
                          >
                            <EditIcon
                              className={classes.iconButtonCustom}
                              onClick={() => handleEditApprovalLevel(level)}
                              size="sm"
                            />
                          </Tooltip>
                          <Tooltip
                            title={t("program_setup.actions.delete")}
                            arrow
                          >
                            <DeleteIcon
                              className={classes.iconButtonCustom}
                              onClick={() =>
                                handleOpenDeleteDialog(
                                  "approvalLevel",
                                  level.id,
                                  level.name
                                )
                              }
                              size="sm"
                            />
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
            <GridContainer
              justifyContent="space-between"
              alignItems="center"
              style={{
                marginTop: "40px",
                marginBottom: "20px",
                position: "relative", // Add this line
              }}
            >
              <GridItem>
                <Typography variant="h6">
                  {t("program_setup.approval_flow.assign_approvers")}
                </Typography>
              </GridItem>

              {isSavingApprovers && (
                <GridItem
                  style={{
                    position: "absolute",
                    right: "40px",
                    top: "10px",
                  }}
                >
                  <ThreeDots
                    color={clientColor}
                    height={20}
                    width={20}
                    ariaLabel="loading"
                  />
                </GridItem>
              )}

              <GridItem>
                <Button
                  justIcon
                  color="client"
                  className={cx({
                    [classes.cardButton]: true,
                    [classes.attention]:
                      hasApproverChanges || isSavingApprovers,
                    [classes.loadingAnimation]: !isSavingApprovers,
                    [classes.actionDisabled]:
                      !hasApproverChanges || isSavingApprovers,
                  })}
                  onClick={handleSaveApprovers}
                  disabled={!hasApproverChanges || isSavingApprovers}
                >
                  <Save className={classes.cardButtonIcon} />
                </Button>
              </GridItem>
            </GridContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.tableHeadCell}
                    onClick={() => handleSortBranches("name")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>{t("program_setup.table_head.branch")}</span>
                      <FontAwesomeIcon
                        icon={
                          sortConfigBranches.key === "name"
                            ? sortConfigBranches.direction === "ascending"
                              ? faSortUp
                              : faSortDown
                            : faSort
                        }
                        className={
                          sortConfigBranches.key === "name"
                            ? `${classes.sortIcon} ${classes.activeSortIcon}`
                            : classes.sortIcon
                        }
                      />
                    </div>
                  </TableCell>
                  {approvalLevels.map((level) => (
                    <TableCell
                      key={level.id}
                      className={classes.tableHeadCell}
                      align="center"
                    >
                      {level.name}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortData(
                  // Apply the Branch filter

                  workfrontFilterBranch
                    ? branches.filter(
                        (branch) => branch.branch === workfrontFilterBranch
                      )
                    : branches,
                  sortConfigBranches
                ).map((branch) => (
                  <TableRow key={branch.id}>
                    <TableCell>{branch.name}</TableCell>
                    {approvalLevels.map((level) => (
                      <TableCell
                        key={`${branch.id}-${level.id}`}
                        align="center"
                      >
                        <FormControl
                          fullWidth
                          className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                          size="small"
                        >
                          <ReactSelect
                            isMulti
                            options={systemUsers.map((user) => ({
                              value: user.id,
                              label: `${user.full_name} (${user.email})`,
                            }))}
                            value={
                              approvalFlow[branch.id] &&
                              approvalFlow[branch.id][level.id]
                                ? approvalFlow[branch.id][level.id]
                                    .map((userId) => {
                                      const user = systemUsers.find(
                                        (u) => u.id === userId
                                      );
                                      return user
                                        ? {
                                            value: user.id,
                                            label: `${user.full_name}`, // Fixed here
                                          }
                                        : null;
                                    })
                                    .filter(Boolean)
                                : []
                            }
                            onChange={(selectedOptions) =>
                              handleApprovalFlowChange(
                                branch.id,
                                level.id,
                                selectedOptions
                              )
                            }
                            styles={customStyles}
                            placeholder={t("program_setup.select_approver")}
                            closeMenuOnSelect={false}
                            isOptionDisabled={() =>
                              approvalFlow[branch.id] &&
                              approvalFlow[branch.id][level.id] &&
                              approvalFlow[branch.id][level.id].length >=
                                MAX_APPROVERS_PER_CELL
                            }
                          />
                          <Typography variant="body2" color="textSecondary">
                            {approvalFlow[branch.id] &&
                            approvalFlow[branch.id][level.id]
                              ? `${approvalFlow[branch.id][level.id].length} de ${MAX_APPROVERS_PER_CELL} selecionados.`
                              : `0 de ${MAX_APPROVERS_PER_CELL} selecionados.`}
                          </Typography>
                        </FormControl>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TabPanel>
          */}
          <TabPanel value={tabValue} index={2}>
            {/* KPIs tab content */}
            {/* Program KPIs */}
            <GridContainer
              spacing={2} // Espaçamento entre os GridItems
              alignItems="center" // Alterado para 'center' para alinhar verticalmente pelo centro
              justifyContent="space-between" // Mantém a distribuição dos grupos
              style={{ marginBottom: "20px" }}
            >
              {/* Filtro por Tipo de KPI */}
              <GridItem xs={12} sm={5} md={3} lg={3}>
                {" "}
                {/* Ajuste os breakpoints conforme necessário */}
                <FormControl fullWidth className={classes.formControl}>
                  <TextField
                    select
                    label={t("program_setup.kpis.filter.type_label")}
                    value={filterKpiType}
                    onChange={(e) => setFilterKpiType(e.target.value)}
                    variant="standard"
                    // size="small" // Removido size="small" temporariamente para verificar alinhamento base
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{ classes: { root: classes.labelText } }}
                  >
                    <MenuItem value="">
                      <em>{t("program_setup.kpis.filter.all_types")}</em>
                    </MenuItem>
                    {kpiTypeOptions.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              </GridItem>

              {/* Espaçador Flexível (para empurrar o botão para a direita se os filtros não ocuparem todo o espaço) */}
              {/* Este GridItem só terá efeito se os filtros não preencherem o espaço antes do botão */}
              <GridItem style={{ flexGrow: 1 }} />

              {/* Botão Adicionar KPI */}
              <GridItem xs={12} sm="auto" md="auto">
                {" "}
                {/* sm="auto" para não quebrar linha em telas pequenas se houver espaço */}
                <Button
                  color="client"
                  className={classes.cardButton}
                  onClick={handleOpenProgramKPIDrawer}
                  size="sm"
                  style={{ marginTop: "0px", marginBottom: "0px" }} // Remover margens que podem causar desalinhamento
                >
                  <AddCircle className={classes.cardButtonIcon} />
                </Button>
              </GridItem>
            </GridContainer>

            {/* KPIs table - MANTENDO SUA ESTRUTURA ORIGINAL */}
            {isLoadingKPIs ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "200px",
                }}
              >
                <ThreeDots
                  color={clientColor}
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <Table>
                {" "}
                {/* Seu <Table> original */}
                <TableHead>
                  <TableRow>
                    {/* "Name" column */}
                    <TableCell
                      className={classes.tableHeadCell}
                      onClick={() => handleSortProgramKPIs("name")}
                      style={{ cursor: "pointer" }}
                    >
                      <div className={classes.tableHeaderIcon}>
                        <span>{t("program_setup.kpis.table_head.name")}</span>
                        <FontAwesomeIcon
                          icon={
                            sortConfigProgramKPIs.key === "name"
                              ? sortConfigProgramKPIs.direction === "ascending"
                                ? faSortUp
                                : faSortDown
                              : faSort
                          }
                          className={
                            sortConfigProgramKPIs.key === "name"
                              ? `${classes.sortIcon} ${classes.activeSortIcon}`
                              : classes.sortIcon
                          }
                        />
                      </div>
                    </TableCell>

                    {/* "Description" column */}
                    <TableCell
                      className={classes.tableHeadCell}
                      onClick={() => handleSortProgramKPIs("description")}
                      style={{ cursor: "pointer" }}
                    >
                      <div className={classes.tableHeaderIcon}>
                        <span>
                          {t("program_setup.kpis.table_head.description")}
                        </span>
                        <FontAwesomeIcon
                          icon={
                            sortConfigProgramKPIs.key === "description"
                              ? sortConfigProgramKPIs.direction === "ascending"
                                ? faSortUp
                                : faSortDown
                              : faSort
                          }
                          className={
                            sortConfigProgramKPIs.key === "description"
                              ? `${classes.sortIcon} ${classes.activeSortIcon}`
                              : classes.sortIcon
                          }
                        />
                      </div>
                    </TableCell>

                    {/* "Unit" column */}
                    <TableCell
                      className={classes.tableHeadCell}
                      onClick={() => handleSortProgramKPIs("unit")}
                      style={{ cursor: "pointer" }}
                    >
                      <div className={classes.tableHeaderIcon}>
                        <span>{t("program_setup.kpis.table_head.unit")}</span>
                        <FontAwesomeIcon
                          icon={
                            sortConfigProgramKPIs.key === "unit"
                              ? sortConfigProgramKPIs.direction === "ascending"
                                ? faSortUp
                                : faSortDown
                              : faSort
                          }
                          className={
                            sortConfigProgramKPIs.key === "unit"
                              ? `${classes.sortIcon} ${classes.activeSortIcon}`
                              : classes.sortIcon
                          }
                        />
                      </div>
                    </TableCell>

                    {/* NOVA COLUNA: "Type" */}
                    <TableCell
                      className={classes.tableHeadCell}
                      onClick={() => handleSortProgramKPIs("type")}
                      style={{ cursor: "pointer" }}
                    >
                      <div className={classes.tableHeaderIcon}>
                        <span>{t("program_setup.kpis.table_head.type")}</span>
                        <FontAwesomeIcon
                          icon={
                            sortConfigProgramKPIs.key === "type"
                              ? sortConfigProgramKPIs.direction === "ascending"
                                ? faSortUp
                                : faSortDown
                              : faSort
                          }
                          className={
                            sortConfigProgramKPIs.key === "type"
                              ? `${classes.sortIcon} ${classes.activeSortIcon}`
                              : classes.sortIcon
                          }
                        />
                      </div>
                    </TableCell>

                    {/* Coluna "Subtype" - Já existia, apenas confirmando */}
                    <TableCell
                      className={classes.tableHeadCell}
                      onClick={() => handleSortProgramKPIs("subtype")}
                      style={{ cursor: "pointer" }}
                    >
                      <div className={classes.tableHeaderIcon}>
                        <span>
                          {t("program_setup.kpis.table_head.subtype")}
                        </span>
                        <FontAwesomeIcon
                          icon={
                            sortConfigProgramKPIs.key === "subtype"
                              ? sortConfigProgramKPIs.direction === "ascending"
                                ? faSortUp
                                : faSortDown
                              : faSort
                          }
                          className={
                            sortConfigProgramKPIs.key === "subtype"
                              ? `${classes.sortIcon} ${classes.activeSortIcon}`
                              : classes.sortIcon
                          }
                        />
                      </div>
                    </TableCell>

                    {/* NOVA COLUNA: "Cumulative" */}
                    <TableCell
                      className={classes.tableHeadCell}
                      onClick={() => handleSortProgramKPIs("is_cumulative")}
                      style={{ cursor: "pointer" }}
                      align="center"
                    >
                      <div
                        className={classes.tableHeaderIcon}
                        style={{ justifyContent: "center" }}
                      >
                        {" "}
                        {/* Centralizar conteúdo do header */}
                        <span>
                          {t("program_setup.kpis.table_head.cumulative")}
                        </span>
                        <FontAwesomeIcon
                          icon={
                            sortConfigProgramKPIs.key === "is_cumulative"
                              ? sortConfigProgramKPIs.direction === "ascending"
                                ? faSortUp
                                : faSortDown
                              : faSort
                          }
                          className={
                            sortConfigProgramKPIs.key === "is_cumulative"
                              ? `${classes.sortIcon} ${classes.activeSortIcon}`
                              : classes.sortIcon
                          }
                        />
                      </div>
                    </TableCell>

                    {/* "Actions" column */}
                    <TableCell
                      className={classes.tableHeadCell}
                      align="center"
                      style={{ cursor: "default" }}
                    >
                      {t("program_setup.kpis.table_head.actions")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Usando filteredProgramKPIs aqui */}
                  {sortData(filteredProgramKPIs, sortConfigProgramKPIs).map(
                    (kpi) => (
                      <TableRow key={kpi.id}>
                        <TableCell>{kpi.name}</TableCell>
                        <TableCell>{kpi.description}</TableCell>
                        <TableCell>{kpi.unit}</TableCell>
                        {/* Exibição do Tipo */}
                        <TableCell>
                          {kpiTypeOptions.find((opt) => opt.value === kpi.type)
                            ?.label || kpi.type}
                        </TableCell>
                        <TableCell>
                          {/* Usando kpiSubTypeOptions do estado, que agora vem da API */}
                          {kpiSubTypeOptions.find(
                            (option) => option.value === kpi.subtype
                          )?.label ||
                            kpi.subtype ||
                            "-"}
                        </TableCell>
                        {/* Exibição do Acumulativo */}
                        <TableCell align="center">
                          <MuiCheckbox
                            checked={kpi.is_cumulative || false}
                            disabled
                            style={{ padding: 0 }}
                            classes={{
                              // Aplicando classes para cor do cliente
                              root: classes.checkboxRoot, // Se tiver uma classe geral para checkbox
                              checked: classes.checkboxChecked, // Estilo quando checado
                              colorPrimary: classes.checkboxColorPrimary, // Cor primária (se usar)
                            }}
                            // color="primary" // Ou use 'default' e estilize via classes
                          />
                        </TableCell>
                        <TableCell align="center">
                          <div className={classes.actionIconsCustom}>
                            <Tooltip
                              title={t("program_setup.actions.edit")}
                              arrow
                            >
                              <EditIcon
                                className={classes.iconButtonCustom}
                                onClick={() => handleEditProgramKPI(kpi)}
                                // size="small" // Removido se não estava no seu original
                              />
                            </Tooltip>
                            <Tooltip
                              title={t("program_setup.actions.delete")}
                              arrow
                            >
                              <DeleteIcon
                                className={classes.iconButtonCustom}
                                onClick={() =>
                                  handleOpenDeleteDialog(
                                    "kpi",
                                    kpi.id,
                                    kpi.name
                                  )
                                }
                                // size="small" // Removido se não estava no seu original
                              />
                            </Tooltip>
                          </div>
                        </TableCell>
                      </TableRow>
                    )
                  )}
                </TableBody>
              </Table>
            )}
          </TabPanel>
          {/* **ADDED: TabPanel for impacts ** */}
          <TabPanel value={tabValue} index={3}>
            {/* Contents of the impact registration tab */}
            {/* Add button header */}
            <GridContainer
              justifyContent="flex-end"
              style={{ marginBottom: "20px" }}
            >
              <GridItem>
                <Button
                  color="client"
                  className={classes.cardButton}
                  onClick={handleOpenImpactDrawer}
                  disabled={false}
                  size="sm" // Keeping the size according to its original code
                >
                  <AddCircle className={classes.cardButtonIcon} />
                </Button>
              </GridItem>
            </GridContainer>
            {/* Impact Table */}
            <Table>
              <TableHead>
                <TableRow>
                  {/* "Impact" column with ordering icons */}
                  <TableCell
                    className={classes.tableHeadCell}
                    onClick={() => handleSortImpacts("impact")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>{t("program_setup.table_head.impact")}</span>
                      <FontAwesomeIcon
                        icon={
                          sortConfigImpacts.key === "impact"
                            ? sortConfigImpacts.direction === "ascending"
                              ? faSortUp
                              : faSortDown
                            : faSort
                        }
                        className={
                          sortConfigImpacts.key === "impact"
                            ? `${classes.sortIcon} ${classes.activeSortIcon}`
                            : classes.sortIcon
                        }
                      />
                    </div>
                  </TableCell>

                  {/* "Impact Description" column with sorting icons */}
                  <TableCell
                    className={classes.tableHeadCell}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>
                        {t("program_setup.table_head.impact_description")}
                      </span>
                    </div>
                  </TableCell>

                  {/* "Actions" column without ordering icons */}
                  <TableCell
                    className={classes.tableHeadCell}
                    align="center"
                    style={{ cursor: "default" }}
                  >
                    {t("program_setup.table_head.actions")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortData(impacts, sortConfigImpacts).map((impact) => (
                  <TableRow key={impact.id}>
                    {/* "Impact" column */}
                    <TableCell>{impact.impact}</TableCell>

                    {/* "Impact Description" column */}
                    <TableCell>{impact.description}</TableCell>

                    {/* "Actions" column */}
                    <TableCell align="center">
                      <div className={classes.actionIconsCustom}>
                        <Tooltip title={t("program_setup.actions.edit")} arrow>
                          <EditIcon
                            className={classes.iconButtonCustom}
                            onClick={() => handleEditImpact(impact)}
                            size="small" // Keeping the size according to its original code
                          />
                        </Tooltip>
                        <Tooltip
                          title={t("program_setup.actions.delete")}
                          arrow
                        >
                          <DeleteIcon
                            className={classes.iconButtonCustom}
                            onClick={() =>
                              handleOpenDeleteDialog(
                                "impact",
                                impact.id,
                                impact.impact
                              )
                            }
                            size="small" // Keeping the size according to its original code
                          />
                        </Tooltip>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TabPanel>
          {/* Drawers para Branches */}
          <Drawer
            anchor="right"
            open={branchDrawerOpen}
            onClose={() => {
              const isEditing = editingBranchId !== null;
              if (isEditing && hasUnsavedBranchChanges) {
                setOnDiscardConfirm(() => () => {
                  // This is what we do if user discards

                  handleCloseBranchDrawer();
                });
                setOnDiscardCancel(() => () => {
                  // do nothing => keep drawer open

                  setBranchDrawerOpen(true);
                });
                setUnsavedDialogOpen(true);
              } else {
                handleCloseBranchDrawer();
              }
            }}
            BackdropProps={{
              style: { backgroundColor: "#000", opacity: "0.1" },
            }}
            PaperProps={{
              style: {
                // Opacity: "0.95",

                borderRadius: "10px",
                margin: "1vh 1vh 1vh 0",
                height: "98vh",
              },
            }}
          >
            <div className={classes.drawer}>
              <Typography variant="h6" gutterBottom>
                {editingBranchId !== null
                  ? t("program_setup.drawer.branch.edit_title")
                  : t("program_setup.drawer.branch.title")}
              </Typography>
              <form noValidate autoComplete="off">
                <Grid container spacing={1}>
                  {/* Branch name */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label={t("program_setup.drawer.branch.fields.name")}
                      name="name"
                      value={newBranch.name}
                      onChange={handleBranchChange}
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{ classes: { input: classes.inputText } }}
                      InputLabelProps={{
                        classes: { root: classes.labelText },
                      }}
                    />
                  </Grid>
                  {/* Branch leader */}
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <ReactSelect
                        options={systemUsers.map((user) => ({
                          value: user.id,
                          label: `${user.full_name} (${user.email})`,
                        }))}
                        value={
                          systemUsers
                            .map((user) => ({
                              value: user.id,
                              label: `${user.full_name} (${user.email})`,
                            }))
                            .find(
                              (option) => option.value === newBranch.leader
                            ) || null
                        }
                        onChange={(selectedOption) =>
                          handleBranchChange({
                            target: {
                              name: "leader",
                              value: selectedOption
                                ? selectedOption.value
                                : null, // Updates the state
                            },
                          })
                        }
                        placeholder={t(
                          "program_setup.drawer.branch.fields.leader"
                        )}
                        styles={{
                          ...customStyles,
                          control: (base) => ({
                            ...base,
                            minHeight: "32px",
                            height: "50px",
                            fontSize: "14px",
                            marginBottom: "0px", // Adds lower margin of 8px
                          }),
                        }}
                      />
                    </FormControl>
                  </Grid>

                  {/* Branch description */}
                  <Grid item xs={12}>
                    <TextField
                      label={t(
                        "program_setup.drawer.branch.fields.description"
                      )}
                      name="description"
                      value={newBranch.description}
                      onChange={handleBranchChange}
                      multiline
                      rows={4}
                      fullWidth
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{ classes: { input: classes.inputText } }}
                      InputLabelProps={{
                        classes: { root: classes.labelText },
                      }}
                    />
                  </Grid>

                  {/* Save button */}
                  <GridItem
                    style={{
                      zIndex: 1000,
                      position: "absolute",
                      right: "15px",
                      top: "10px",
                    }}
                  >
                    <Button
                      justIcon
                      color="client"
                      className={classes.cardButton}
                      onClick={handleSaveBranch}
                      disabled={
                        !newBranch.name ||
                        !newBranch.leader ||
                        !newBranch.description
                      }
                    >
                      <Save className={classes.cardButtonIcon} />
                    </Button>
                  </GridItem>
                </Grid>
              </form>
            </div>
          </Drawer>
          {/* Drawers for Workfronts */}
          <Drawer
            anchor="right"
            open={workfrontDrawerOpen}
            onClose={() => {
              const isEditing = editingWorkfrontId !== null;
              if (isEditing && hasUnsavedWorkfrontChanges) {
                setOnDiscardConfirm(() => () => {
                  // if user discards

                  handleCloseWorkfrontDrawer();
                });
                setOnDiscardCancel(() => () => {
                  // keep drawer open

                  setWorkfrontDrawerOpen(true);
                });
                setUnsavedDialogOpen(true);
              } else {
                handleCloseWorkfrontDrawer();
              }
            }}
            BackdropProps={{
              style: { backgroundColor: "#000", opacity: "0.1" },
            }}
            PaperProps={{
              style: {
                // Opacity: "0.95",

                borderRadius: "10px",
                margin: "1vh 1vh 1vh 0",
                height: "98vh",
              },
            }}
          >
            <div className={classes.drawer}>
              <Typography variant="h6" gutterBottom>
                {editingWorkfrontId !== null
                  ? t("program_setup.drawer.workfront.edit_title")
                  : t("program_setup.drawer.workfront.title")}
              </Typography>
              <form noValidate autoComplete="off">
                <Grid container spacing={2}>
                  {/* Nome do Workfront */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label={t("program_setup.drawer.workfront.fields.name")}
                      name="name"
                      value={newWorkfront.name}
                      onChange={handleWorkfrontChange}
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{ classes: { input: classes.inputText } }}
                      InputLabelProps={{
                        classes: { root: classes.labelText },
                      }}
                    />
                  </Grid>

                  {/* Workfront leader */}
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <ReactSelect
                        options={systemUsers.map((user) => ({
                          value: user.id,
                          label: `${user.full_name} (${user.email})`,
                        }))}
                        value={
                          systemUsers
                            .map((user) => ({
                              value: user.id,
                              label: `${user.full_name} (${user.email})`,
                            }))
                            .find(
                              (option) => option.value === newWorkfront.leader
                            ) || null
                        }
                        onChange={(selectedOption) =>
                          handleWorkfrontChange({
                            target: {
                              name: "leader",
                              value: selectedOption
                                ? selectedOption.value
                                : null, // Updates the state
                            },
                          })
                        }
                        placeholder={t(
                          "program_setup.drawer.workfront.fields.leader"
                        )}
                        styles={{
                          ...customStyles,
                          control: (base) => ({
                            ...base,
                            minHeight: "32px",
                            height: "50px",
                            fontSize: "14px",
                            marginBottom: "0px", // Adds lower margin
                          }),
                        }}
                      />
                    </FormControl>
                  </Grid>

                  {/* Branch */}
                  <Grid item xs={12}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <TextField
                        select
                        fullWidth
                        labelId="branch-label"
                        label={t(
                          "program_setup.drawer.workfront.fields.branch"
                        )}
                        name="branch"
                        value={newWorkfront.branch}
                        onChange={handleWorkfrontChange}
                        classes={{ root: classes.textFieldRoot }}
                        InputProps={{ classes: { input: classes.inputText } }}
                        InputLabelProps={{
                          classes: { root: classes.labelText },
                        }}
                      >
                        {branches.map((branch) => (
                          <MenuItem
                            key={branch.id}
                            value={branch.name}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                          >
                            {branch.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                  </Grid>

                  {/* Start date */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={t(
                        "program_setup.drawer.workfront.fields.start_date"
                      )}
                      name="startDate"
                      type="date"
                      value={newWorkfront.startDate}
                      onChange={handleWorkfrontChange}
                      fullWidth
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{ classes: { input: classes.inputText } }}
                      InputLabelProps={{
                        classes: { root: classes.labelText },
                        shrink: true,
                      }}
                    />
                  </Grid>

                  {/* End date */}
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={t(
                        "program_setup.drawer.workfront.fields.end_date"
                      )}
                      name="endDate"
                      type="date"
                      value={newWorkfront.endDate}
                      onChange={handleWorkfrontChange}
                      fullWidth
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{ classes: { input: classes.inputText } }}
                      InputLabelProps={{
                        classes: { root: classes.labelText },
                        shrink: true,
                      }}
                    />
                  </Grid>

                  {/* Description */}
                  <Grid item xs={12}>
                    <TextField
                      label={t(
                        "program_setup.drawer.workfront.fields.description"
                      )}
                      name="description"
                      value={newWorkfront.description}
                      onChange={handleWorkfrontChange}
                      multiline
                      rows={4}
                      fullWidth
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{ classes: { input: classes.inputText } }}
                      InputLabelProps={{
                        classes: { root: classes.labelText },
                      }}
                    />
                  </Grid>
                  {/* Save button */}
                  <GridItem
                    style={{
                      zIndex: 1000,
                      position: "absolute",
                      right: "15px",
                      top: "10px",
                    }}
                  >
                    <Button
                      justIcon
                      color="client"
                      className={classes.cardButton}
                      onClick={handleSaveWorkfront}
                      disabled={
                        !newWorkfront.name ||
                        !newWorkfront.leader ||
                        !newWorkfront.branch ||
                        !newWorkfront.startDate ||
                        !newWorkfront.endDate ||
                        !newWorkfront.description
                      }
                    >
                      <Save className={classes.cardButtonIcon} />
                    </Button>
                  </GridItem>
                </Grid>
              </form>
            </div>
          </Drawer>
          {/* Drawers para Approval Flow */}
          <Drawer
            anchor="right"
            open={approvalDrawerOpen}
            onClose={() => {
              const isEditing = editingApprovalLevelId !== null;
              if (isEditing && hasUnsavedApprovalLevelChanges) {
                setOnDiscardConfirm(() => () => {
                  handleCloseApprovalDrawer();
                });
                setOnDiscardCancel(() => () => {
                  setApprovalDrawerOpen(true);
                });
                setUnsavedDialogOpen(true);
              } else {
                handleCloseApprovalDrawer();
              }
            }}
            BackdropProps={{
              style: { backgroundColor: "#000", opacity: "0.1" },
            }}
            PaperProps={{
              style: {
                // Opacity: "0.95",

                borderRadius: "10px",
                margin: "1vh 1vh 1vh 0",
                height: "98vh",
              },
            }}
          >
            <div className={classes.drawer}>
              <Typography variant="h6" gutterBottom>
                {editingApprovalLevelId !== null
                  ? t("program_setup.drawer.approval_flow.edit_title")
                  : t("program_setup.drawer.approval_flow.title")}
              </Typography>
              <form noValidate autoComplete="off">
                <TextField
                  label={t("program_setup.drawer.approval_flow.fields.name")}
                  name="name"
                  value={newApprovalLevel.name}
                  onChange={handleApprovalLevelChange}
                  fullWidth
                  classes={{ root: classes.textFieldRoot }}
                  InputProps={{ classes: { input: classes.inputText } }}
                  InputLabelProps={{ classes: { root: classes.labelText } }}
                />
                <GridItem
                  style={{
                    zIndex: 1000,
                    position: "absolute",
                    right: "15px",
                    top: "10px",
                  }}
                >
                  <Button
                    justIcon
                    color="client"
                    className={classes.cardButton}
                    onClick={handleSaveApprovalLevel}
                    disabled={!newApprovalLevel.name}
                  >
                    <Save className={classes.cardButtonIcon} />
                  </Button>
                </GridItem>
              </form>
            </div>
          </Drawer>
          {/* Drawers for Program KPIs */}
          <Drawer
            anchor="right"
            open={programKPIDrawerOpen}
            onClose={handleCloseProgramKPIDrawer} // Sua função de fechar original
            // maxWidth="md" // Removido se não era o original do seu Drawer
            PaperProps={{ style: { width: "800px" } }} // Seu PaperProps original
          >
            {/* Header do Drawer - mantendo sua estrutura original */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Typography
                variant="h6" // Seu variant original
                style={{ position: "relative", padding: "16px 40px 0 16px" }} // Seu estilo original
              >
                {/* O título original era "new_initiatives.fields.add_kpi", ajuste se necessário */}
                {editingProgramKPIId
                  ? t("program_setup.kpis.drawer.edit_title")
                  : t("program_setup.kpis.drawer.add_title")}
              </Typography>
              <div
                style={{
                  // Seu container de botões original
                  display: "flex",
                  position: "absolute",
                  top: "20px",
                  right: "17px",
                  gap: "4px",
                }}
              >
                {/* Botão Fechar - seu ícone CloseIcon */}
                <Tooltip title={t("program_setup.actions.close")}>
                  <CloseIcon
                    className={classes.iconButtonCustom} // Sua classe de estilo
                    onClick={handleCloseProgramKPIDrawer}
                  />
                </Tooltip>
                <Tooltip
                  title={
                    isSavingKpi
                      ? t("new_initiatives.fields.saving")
                      : hasUnsavedKPIChanges // Usando hasUnsavedKPIChanges
                        ? t("new_initiatives.fields.save")
                        : t("new_initiatives.fields.no_changes")
                  }
                >
                  <span>
                    {" "}
                    {/* Span para Tooltip em botão desabilitado */}
                    <Button
                      justIcon // Seu prop original
                      color="client" // Sua cor original
                      className={cx(classes.cardButton, {
                        // Suas classes originais
                        [classes.attention]:
                          hasUnsavedKPIChanges && !isSavingKpi,
                        [classes.actionDisabled]:
                          !hasUnsavedKPIChanges || isSavingKpi,
                      })}
                      onClick={handleSaveProgramKPI}
                      disabled={!hasUnsavedKPIChanges || isSavingKpi} // Lógica de desabilitar
                    >
                      {isSavingKpi ? (
                        <ThreeDots color="white" height={18} width={18} />
                      ) : (
                        <Save className={classes.cardButtonIcon} />
                      )}
                    </Button>
                  </span>
                </Tooltip>
              </div>
            </div>

            {/* Conteúdo do Drawer  */}
            <div style={{ padding: "20px", marginTop: "-10px" }}>
              {" "}
              <Grid container spacing={2}>
                {" "}
                <Grid
                  item
                  xs={12}
                  className={classes.kpiDrawerDividerContainer}
                >
                  <div className={classes.kpiDrawerDividerLine} />
                  <Typography className={classes.kpiDrawerDividerText}>
                    {t("program_setup.kpis.drawer.section_details")}{" "}
                    {/* Ex: "Details" */}
                  </Typography>
                  <div className={classes.kpiDrawerDividerLine} />
                </Grid>
                {/* KPI Name */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label={t("new_initiatives.fields.kpi_name")}
                    name="name"
                    value={newProgramKPI.name}
                    onChange={handleProgramKPIChange}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{ classes: { root: classes.labelText } }}
                    required // Adicionado para indicar campo obrigatório
                  />
                </Grid>
                {/* Reporting Format */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label={t(
                      "program_setup.kpis.fields.reporting_format",
                      "Reporting Format"
                    )}
                    name="reporting_format"
                    value={newProgramKPI.reporting_format}
                    onChange={handleProgramKPIChange}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{ classes: { root: classes.labelText } }}
                    size="small"
                    required
                  >
                    {reportingFormatOptions.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        classes={{
                          // Seus estilos de MenuItem
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {/* KPI Type (Program/Initiative) - NOVO CAMPO */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label={t("program_setup.kpis.fields.type")}
                    name="type"
                    value={newProgramKPI.type}
                    onChange={handleProgramKPIChange}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{ classes: { root: classes.labelText } }}
                    disabled={newProgramKPI.reporting_format === "centralized"} // Trava aqui
                    helperText={
                      newProgramKPI.reporting_format === "centralized"
                        ? t(
                            "program_setup.kpis.helpers.centralized_kpi_must_be_program",
                            "Centralized KPIs must be Program type"
                          )
                        : ""
                    }
                    required
                  >
                    {kpiTypeOptions.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        classes={{
                          // Seus estilos de MenuItem
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {/* KPI SubType */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    fullWidth
                    label={t("new_initiatives.fields.kpi_subtype")}
                    name="subtype"
                    value={newProgramKPI.subtype}
                    onChange={handleProgramKPIChange}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{ classes: { root: classes.labelText } }}
                    required
                  >
                    {(newProgramKPI.type === "program"
                      ? kpiSubTypeOptions.filter((opt) =>
                          ["topo", "financial", "budget"].includes(opt.value)
                        )
                      : kpiSubTypeOptions
                    ) // Para initiative, permitir todos os subtipos carregados da API
                      .map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.value}
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                {/* KPI Unit */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label={t("new_initiatives.fields.kpi_unit")}
                    name="unit"
                    value={newProgramKPI.unit}
                    onChange={handleProgramKPIChange}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{ classes: { root: classes.labelText } }}
                  />
                </Grid>
                {/* Is Cumulative Checkbox - NOVO CAMPO */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    paddingTop: "8px",
                  }}
                >
                  {" "}
                  {/* Ajuste para alinhar melhor */}
                  <FormControlLabel
                    control={
                      <MuiCheckbox
                        checked={newProgramKPI.is_cumulative}
                        onChange={handleProgramKPIChange}
                        name="is_cumulative"
                        // Aplicando classes para cor do cliente
                        classes={{
                          root: classes.checkboxRoot, // Sua classe geral para checkbox
                          checked: classes.checkboxCheckedClient, // Uma classe específica para cor do cliente quando checado
                          // Ou use color="primary" e defina a cor primária do tema para clientColor
                        }}
                        // Se preferir usar a prop 'color' e seu tema já estiver configurado:
                        // color={userDetails.implementation_color ? "primary" : "default"}
                      />
                    }
                    label={t("program_setup.kpis.fields.is_cumulative")}
                    classes={{ label: classes.labelText }} // Estilo do label se necessário
                  />
                </Grid>
                {/* KPI Description */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={4} // Seu rows original
                    label={t("new_initiatives.fields.kpi_description")}
                    name="description"
                    value={newProgramKPI.description}
                    onChange={handleProgramKPIChange}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{
                      classes: { root: classes.labelText },
                      shrink: true, // Manter o shrink original
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  className={classes.kpiDrawerDividerContainer}
                >
                  <div className={classes.kpiDrawerDividerLine} />
                  <Typography className={classes.kpiDrawerDividerText}>
                    {t("program_setup.kpis.drawer.section_parameters")}
                  </Typography>
                  <div className={classes.kpiDrawerDividerLine} />
                </Grid>
                {/* KPI Performance Orientation */}
                <Grid item xs={12}>
                  <TextField
                    select
                    fullWidth
                    label={t(
                      "new_initiatives.fields.kpi_performance_orientation"
                    )}
                    name="performance_orientation"
                    value={newProgramKPI.performance_orientation} //
                    onChange={(event) => {
                      const newOrientation = event.target.value;
                      setNewProgramKPI((prev) => ({
                        ...prev,
                        performance_orientation: newOrientation,
                        // Resetar TODOS os campos de threshold
                        green_min_value: "",
                        green_max_value: "",
                        yellow_min_value_1: "",
                        yellow_max_value_1: "",
                        yellow_min_value_2: "",
                        yellow_max_value_2: "",
                        red_threshold_value: "", // Para ASC/DESC Red
                        red_modular_below_value: "", // Para MOD Red
                        red_modular_above_value: "", // Para MOD Red
                      }));
                      setHasUnsavedKPIChanges(true);
                    }}
                    classes={{ root: classes.textFieldRoot }} // Mantenha seus estilos
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{ classes: { root: classes.labelText } }}
                    size="small" // Ajuste para o size que você está usando consistentemente
                    required
                  >
                    {/* Verifica se kpiPerformanceOrientationOptions existe e é um array antes de mapear */}
                    {Array.isArray(kpiPerformanceOrientationOptions) &&
                      kpiPerformanceOrientationOptions.map((option) => (
                        <MenuItem
                          key={option.value}
                          value={option.value} // Ex: "ASC", "DESC", "MOD"
                          classes={{
                            // Mantenha seus estilos de MenuItem
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                  </TextField>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2" // Seu variant original
                    style={{
                      // Seu estilo original
                      marginBottom: "1px",
                      marginTop: "7px",
                      fontStyle: "italic",
                      color: "#555",
                    }}
                  >
                    {t("new_initiatives.fields.thresholds_explanation")}
                  </Typography>
                </Grid>
                {/* THRESHOLDS - Loop para green/yellow/red */}
                {newProgramKPI.performance_orientation && (
                  <Grid
                    container
                    spacing={2}
                    item
                    xs={12}
                    style={{ marginTop: "10px" }}
                  >
                    {["green", "yellow", "red"].map((color) => {
                      const orientation = newProgramKPI.performance_orientation;
                      const colorHex =
                        color === "green"
                          ? "green"
                          : color === "yellow"
                            ? "#DAA520"
                            : "red";
                      let conditionText = "";

                      // Definir texto da condição para UI
                      if (orientation === "ASC") {
                        if (color === "green")
                          conditionText = t("new_initiatives.fields.above");
                        else if (color === "yellow")
                          conditionText = t("new_initiatives.fields.between");
                        else if (color === "red")
                          conditionText = t("new_initiatives.fields.below");
                      } else if (orientation === "DESC") {
                        if (color === "green")
                          conditionText = t("new_initiatives.fields.below");
                        else if (color === "yellow")
                          conditionText = t("new_initiatives.fields.between");
                        else if (color === "red")
                          conditionText = t("new_initiatives.fields.above");
                      } else if (orientation === "MOD") {
                        if (color === "green")
                          conditionText = t("new_initiatives.fields.between");
                        else if (color === "yellow")
                          conditionText = t(
                            "program_setup.kpis.drawer.yellow_mod_condition"
                          );
                        // Ex: "Faixa 1 (Entre) E Faixa 2 (Entre)"
                        else if (color === "red")
                          conditionText = t(
                            "program_setup.kpis.drawer.red_mod_condition"
                          ); // Ex: "Abaixo de X OU Acima de Y"
                      }

                      return (
                        <Grid
                          item
                          xs={12}
                          md={4}
                          key={color}
                          style={{ marginBottom: "20px" }}
                        >
                          {" "}
                          {/* Aumentado marginBottom */}
                          <Typography
                            variant="subtitle1"
                            style={{ color: colorHex, fontWeight: "bold" }}
                          >
                            {t(`new_initiatives.fields.${color}_condition`)}
                          </Typography>
                          <Typography
                            variant="caption"
                            display="block"
                            style={{ marginBottom: "15px", minHeight: "1.5em" }}
                          >
                            {" "}
                            {/* minHeight para alinhar */}
                            <em>{conditionText}</em>
                          </Typography>
                          {/* GREEN */}
                          {color === "green" && (
                            <>
                              {(orientation === "ASC" ||
                                orientation === "DESC") && (
                                <TextField
                                  fullWidth
                                  type="number"
                                  label={t(
                                    "program_setup.kpis.drawer.value_label"
                                  )}
                                  name="green_min_value" // Usamos min_value para o valor único de green
                                  value={newProgramKPI.green_min_value}
                                  onChange={handleProgramKPIChange}
                                  InputProps={{
                                    endAdornment: <span>%</span>,
                                    classes: { input: classes.inputText },
                                  }}
                                  classes={{ root: classes.textFieldRoot }}
                                  InputLabelProps={{
                                    classes: { root: classes.labelText },
                                  }}
                                  size="small"
                                />
                              )}
                              {orientation === "MOD" && (
                                <Grid container spacing={1}>
                                  <Grid item xs={6}>
                                    <TextField
                                      fullWidth
                                      type="number"
                                      label={t(
                                        "new_initiatives.fields.min_value"
                                      )}
                                      name="green_min_value"
                                      value={newProgramKPI.green_min_value}
                                      onChange={handleProgramKPIChange}
                                      InputProps={{
                                        endAdornment: <span>%</span>,
                                        classes: { input: classes.inputText },
                                      }}
                                      classes={{ root: classes.textFieldRoot }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                      }}
                                      size="small"
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    <TextField
                                      fullWidth
                                      type="number"
                                      label={t(
                                        "new_initiatives.fields.max_value"
                                      )}
                                      name="green_max_value"
                                      value={newProgramKPI.green_max_value}
                                      onChange={handleProgramKPIChange}
                                      InputProps={{
                                        endAdornment: <span>%</span>,
                                        classes: { input: classes.inputText },
                                      }}
                                      classes={{ root: classes.textFieldRoot }}
                                      InputLabelProps={{
                                        classes: { root: classes.labelText },
                                      }}
                                      size="small"
                                    />
                                  </Grid>
                                </Grid>
                              )}
                            </>
                          )}
                          {/* YELLOW */}
                          {color === "yellow" && (
                            <>
                              <Grid container spacing={1}>
                                <Grid item xs={6}>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    label={
                                      t("new_initiatives.fields.min_value") +
                                      (orientation === "MOD" ? " (1)" : "")
                                    }
                                    name="yellow_min_value_1"
                                    value={newProgramKPI.yellow_min_value_1}
                                    onChange={handleProgramKPIChange}
                                    InputProps={{
                                      endAdornment: <span>%</span>,
                                      classes: { input: classes.inputText },
                                    }}
                                    classes={{ root: classes.textFieldRoot }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                    }}
                                    size="small"
                                  />
                                </Grid>
                                <Grid item xs={6}>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    label={
                                      t("new_initiatives.fields.max_value") +
                                      (orientation === "MOD" ? " (1)" : "")
                                    }
                                    name="yellow_max_value_1"
                                    value={newProgramKPI.yellow_max_value_1}
                                    onChange={handleProgramKPIChange}
                                    InputProps={{
                                      endAdornment: <span>%</span>,
                                      classes: { input: classes.inputText },
                                    }}
                                    classes={{ root: classes.textFieldRoot }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                    }}
                                    size="small"
                                  />
                                </Grid>
                              </Grid>
                              {orientation === "MOD" && (
                                <div
                                  style={{
                                    marginTop: "15px",
                                    paddingTop: "15px",
                                    borderTop: "1px dashed #e0e0e0",
                                  }}
                                >
                                  <Typography
                                    variant="caption"
                                    display="block"
                                    style={{
                                      marginBottom: "10px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {t(
                                      "program_setup.kpis.drawer.optional_second_range"
                                    )}
                                  </Typography>
                                  <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                      <TextField
                                        fullWidth
                                        type="number"
                                        label={`${t("new_initiatives.fields.min_value")} (2)`}
                                        name="yellow_min_value_2"
                                        value={newProgramKPI.yellow_min_value_2}
                                        onChange={handleProgramKPIChange}
                                        InputProps={{
                                          endAdornment: <span>%</span>,
                                          classes: { input: classes.inputText },
                                        }}
                                        classes={{
                                          root: classes.textFieldRoot,
                                        }}
                                        InputLabelProps={{
                                          classes: { root: classes.labelText },
                                        }}
                                        size="small"
                                      />
                                    </Grid>
                                    <Grid item xs={6}>
                                      <TextField
                                        fullWidth
                                        type="number"
                                        label={`${t("new_initiatives.fields.max_value")} (2)`}
                                        name="yellow_max_value_2"
                                        value={newProgramKPI.yellow_max_value_2}
                                        onChange={handleProgramKPIChange}
                                        InputProps={{
                                          endAdornment: <span>%</span>,
                                          classes: { input: classes.inputText },
                                        }}
                                        classes={{
                                          root: classes.textFieldRoot,
                                        }}
                                        InputLabelProps={{
                                          classes: { root: classes.labelText },
                                        }}
                                        size="small"
                                      />
                                    </Grid>
                                  </Grid>
                                </div>
                              )}
                            </>
                          )}
                          {/* RED */}
                          {color === "red" && (
                            <>
                              {(orientation === "ASC" ||
                                orientation === "DESC") && (
                                <TextField
                                  fullWidth
                                  type="number"
                                  label={t(
                                    "program_setup.kpis.drawer.value_label"
                                  )}
                                  name="red_threshold_value" // Usado para o valor único de Red em ASC/DESC
                                  value={newProgramKPI.red_threshold_value}
                                  onChange={handleProgramKPIChange}
                                  InputProps={{
                                    endAdornment: <span>%</span>,
                                    classes: { input: classes.inputText },
                                  }}
                                  classes={{ root: classes.textFieldRoot }}
                                  InputLabelProps={{
                                    classes: { root: classes.labelText },
                                  }}
                                  size="small"
                                />
                              )}
                              {orientation === "MOD" && (
                                <>
                                  <TextField
                                    fullWidth
                                    type="number"
                                    label={t(
                                      "program_setup.kpis.drawer.red_below_value_label"
                                    )} // Ex: "Vermelho Abaixo de"
                                    name="red_modular_below_value"
                                    value={
                                      newProgramKPI.red_modular_below_value
                                    }
                                    onChange={handleProgramKPIChange}
                                    InputProps={{
                                      endAdornment: <span>%</span>,
                                      classes: { input: classes.inputText },
                                    }}
                                    classes={{ root: classes.textFieldRoot }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                    }}
                                    size="small"
                                    style={{ marginBottom: "10px" }}
                                  />
                                  <TextField
                                    fullWidth
                                    type="number"
                                    label={t(
                                      "program_setup.kpis.drawer.red_above_value_label"
                                    )} // Ex: "Vermelho Acima de"
                                    name="red_modular_above_value"
                                    value={
                                      newProgramKPI.red_modular_above_value
                                    }
                                    onChange={handleProgramKPIChange}
                                    InputProps={{
                                      endAdornment: <span>%</span>,
                                      classes: { input: classes.inputText },
                                    }}
                                    classes={{ root: classes.textFieldRoot }}
                                    InputLabelProps={{
                                      classes: { root: classes.labelText },
                                    }}
                                    size="small"
                                  />
                                </>
                              )}
                            </>
                          )}
                        </Grid> // Fechamento do Grid item xs={12} md={4}
                      );
                    })}
                  </Grid>
                )}
              </Grid>
            </div>
          </Drawer>

          {/* **ADDED: Drawer for impacts ** */}
          <Drawer
            anchor="right"
            open={impactDrawerOpen}
            onClose={() => {
              const isEditing = editingImpactId !== null;
              if (isEditing && hasUnsavedImpactChanges) {
                setOnDiscardConfirm(() => () => {
                  handleCloseImpactDrawer();
                });
                setOnDiscardCancel(() => () => {
                  setImpactDrawerOpen(true);
                });
                setUnsavedDialogOpen(true);
              } else {
                handleCloseImpactDrawer();
              }
            }}
            BackdropProps={{
              style: { backgroundColor: "#000", opacity: "0.1" },
            }}
            PaperProps={{
              style: {
                // Opacity: "0.95",

                borderRadius: "10px",
                margin: "1vh 1vh 1vh 0",
                height: "98vh",
              },
            }}
          >
            <div className={classes.drawer}>
              <Typography variant="h6" gutterBottom>
                {editingImpactId !== null
                  ? t("program_setup.drawer.impact.edit_title")
                  : t("program_setup.drawer.impact.title")}
              </Typography>
              <form noValidate autoComplete="off">
                <Grid container spacing={2}>
                  {/* Impact field */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label={t("program_setup.drawer.impact.fields.impact")}
                      name="impact"
                      value={newImpact.impact}
                      onChange={handleImpactChange}
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{ classes: { input: classes.inputText } }}
                      InputLabelProps={{
                        classes: { root: classes.labelText },
                      }}
                    />
                  </Grid>

                  {/* Field Description */}
                  <Grid item xs={12}>
                    <TextField
                      label={t(
                        "program_setup.drawer.impact.fields.description"
                      )}
                      name="description"
                      value={newImpact.description}
                      onChange={handleImpactChange}
                      multiline
                      rows={4}
                      fullWidth
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{ classes: { input: classes.inputText } }}
                      InputLabelProps={{
                        classes: { root: classes.labelText },
                      }}
                    />
                  </Grid>

                  {/* Save button */}

                  <GridItem
                    style={{
                      zIndex: 1000,
                      position: "absolute",
                      right: "15px",
                      top: "10px",
                    }}
                  >
                    <Button
                      justIcon
                      color="client"
                      className={classes.cardButton}
                      onClick={handleSaveImpact}
                      disabled={!newImpact.impact || !newImpact.description}
                    >
                      <Save className={classes.cardButtonIcon} />
                    </Button>
                  </GridItem>
                </Grid>
              </form>
            </div>
          </Drawer>
          {/* Exclusion Confirmation Dialogue */}
          <Dialog
            open={deleteDialogOpen}
            onClose={handleCloseDeleteDialog}
            aria-labelledby="delete-confirmation-dialog-title"
            aria-describedby="delete-confirmation-dialog-description"
          >
            <DialogTitle id="delete-confirmation-dialog-title">
              {t("program_setup.dialogs.delete_confirmation.title")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="delete-confirmation-dialog-description">
                {t("program_setup.dialogs.delete_confirmation.text")}{" "}
                {deleteTarget.type === "branch" &&
                  t("program_setup.dialogs.delete_confirmation.textbranch")}
                {deleteTarget.type === "workfront" &&
                  t("program_setup.dialogs.delete_confirmation.textworkfront")}
                {deleteTarget.type === "approvalLevel" &&
                  t(
                    "program_setup.dialogs.delete_confirmation.textapprovallevel"
                  )}
                {deleteTarget.type === "kpi" &&
                  t("program_setup.dialogs.delete_confirmation.textkpi")}
                {deleteTarget.type === "impact" &&
                  t("program_setup.dialogs.delete_confirmation.textimpact")}
                {deleteTarget.type === "user" &&
                  t("program_setup.dialogs.delete_confirmation.textuser")}
                {deleteTarget.type === "accessGroup" &&
                  t(
                    "program_setup.dialogs.delete_confirmation.textaccessgroup"
                  )}{" "}
                <strong>{deleteTarget.name}</strong>?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCloseDeleteDialog}
                color="client"
                size="small"
              >
                {t("program_setup.dialogs.delete_confirmation.button.cancel")}
              </Button>
              <Button
                onClick={handleConfirmDelete}
                color="secondary" // I changed to "Secondary" to follow patterns of material -u
                autoFocus
                size="small"
              >
                {t("program_setup.dialogs.delete_confirmation.button.confirm")}
              </Button>
            </DialogActions>
          </Dialog>
          {/* Unsaved Changes Confirmation Dialog */}
          <Dialog
            open={unsavedDialogOpen}
            onClose={() => {
              setUnsavedDialogOpen(false);
              if (onDiscardCancel) onDiscardCancel();
            }}
            aria-labelledby="discard-changes-dialog-title"
            aria-describedby="discard-changes-dialog-description"
          >
            <DialogTitle>
              {t("program_setup.dialogs.unsaved_changes.title")}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {t("program_setup.dialogs.unsaved_changes.text")}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setUnsavedDialogOpen(false);
                  if (onDiscardCancel) onDiscardCancel();
                }}
                color="client"
              >
                {t("program_setup.dialogs.unsaved_changes.button.cancel")}
              </Button>
              <Button
                onClick={() => {
                  setUnsavedDialogOpen(false);
                  if (onDiscardConfirm) onDiscardConfirm();
                }}
                color="secondary"
                autoFocus
              >
                {t("program_setup.dialogs.unsaved_changes.button.discard")}
              </Button>
            </DialogActions>
          </Dialog>
          {/* Drawers for Branches, Workfronts, Approval Flow, KPIs and impacts already included above */}
        </AccordionDetails>
      </Accordion>

      {/* ==================================================================== */}
      {/* START: UPDATED ACCORDION FOR USER, ROLE & ACCESS MANAGEMENT          */}
      {/* ==================================================================== */}
      <Accordion className={classes.accordionRootCustom} defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <CardHeader
            color="client"
            icon
            style={{ marginTop: "10px", display: "flex", alignItems: "center" }}
          >
            <CardIcon color="client">
              <People />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              {t(
                "program_setup.users_roles_access_title",
                "User, Role & Access Management"
              )}
            </h4>
          </CardHeader>
        </AccordionSummary>
        <AccordionDetails style={{ display: "block" }}>
          <AppBar position="static" color="default" elevation={0}>
            <Tabs
              value={managementTabValue}
              onChange={handleManagementTabChange}
              classes={{ root: classes.tabsRoot, indicator: classes.indicator }}
              variant="fullWidth"
            >
              <Tab
                label={t("program_setup.tabs.roles", "Role Management")}
                {...a11yProps(0)}
              />
              <Tab
                label={t("program_setup.tabs.users", "User Management")}
                {...a11yProps(1)}
              />
              <Tab
                label={t("program_setup.tabs.access_groups", "Access Groups")}
                {...a11yProps(2)}
              />
            </Tabs>
          </AppBar>

          {/* ================================= */}
          {/* TAB PANEL 1: ROLE MANAGEMENT (CORRECTED) */}
          {/* ================================= */}
          <TabPanel value={managementTabValue} index={0}>
            <GridContainer
              justifyContent="space-between"
              alignItems="center"
              style={{ padding: "10px 0" }}
            >
              <GridItem>
                <Typography variant="body2" color="textSecondary">
                  {t("program_setup.roles.description")}
                </Typography>
              </GridItem>
              <GridItem style={{ textAlign: "right" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <Button
                    color="client"
                    size="sm"
                    onClick={() => handleOpenRoleDrawer(null)}
                    className={classes.cardButton}
                  >
                    <AddCircle className={classes.cardButtonIcon} />
                  </Button>
                  <Button
                    justIcon
                    color="client"
                    className={cx({
                      [classes.cardButton]: true,
                      [classes.attention]: hasChanges && !isSavingAllChanges,
                      [classes.actionDisabled]:
                        !hasChanges || isSavingAllChanges,
                    })}
                    onClick={handleSaveAllChanges}
                    disabled={!hasChanges || isSavingAllChanges}
                  >
                    {isSavingAllChanges ? (
                      <ThreeDots color="#FFF" height={15} width={15} />
                    ) : (
                      <Save className={classes.cardButtonIcon} />
                    )}
                  </Button>
                </div>
              </GridItem>
            </GridContainer>

            <TableContainer>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={`${classes.tableHeadCell} ${classes.stickyHeaderCell} ${classes.stickyFirstColumnCell}`}
                      style={{ minWidth: 170, zIndex: 15 }}
                    >
                      {t("program_setup.table_head.role", "Role")}
                    </TableCell>

                    {/* 🔽 FIX: Generate headers from permissionMetadata, not from roles[0] 🔽 */}
                    {permissionMetadata.map((meta) => (
                      <TableCell
                        key={meta.key}
                        align="center"
                        className={`${classes.tableHeadCell} ${classes.stickyHeaderCell}`}
                        style={{ minWidth: 150 }}
                      >
                        <Tooltip
                          title={getPermissionTooltip(t, meta.key)}
                          arrow
                        >
                          <span>{getPermissionHeader(t, meta.key)}</span>
                        </Tooltip>
                      </TableCell>
                    ))}

                    <TableCell
                      className={`${classes.tableHeadCell} ${classes.stickyHeaderCell}`}
                      align="center"
                      style={{ minWidth: 100 }}
                    >
                      {t("program_setup.table_head.actions", "Actions")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoadingRoles ? (
                    <TableRow>
                      <TableCell
                        colSpan={permissionMetadata.length + 2}
                        align="center"
                      >
                        <ThreeDots color={clientColor} height={40} width={40} />
                      </TableCell>
                    </TableRow>
                  ) : (
                    // 🔽 FIX: Render only roles where is_default is false 🔽
                    roles
                      .filter((role) => !role.is_default)
                      .map((role) => (
                        <TableRow key={role.id}>
                          <TableCell className={classes.stickyFirstColumnCell}>
                            <Tooltip title={role.description || ""} arrow>
                              <span>{role.name}</span>
                            </Tooltip>
                          </TableCell>

                          {/* 🔽 FIX: Iterate over permissionMetadata to ensure column order matches header 🔽 */}
                          {permissionMetadata.map((meta) => (
                            <TableCell
                              key={`${role.id}-${meta.key}`}
                              align="center"
                            >
                              <MuiCheckbox
                                // A role que não é default NUNCA será desabilitada por is_default
                                disabled={isSavingAllChanges}
                                checked={
                                  roleChanges[role.id]?.[meta.key] !== undefined
                                    ? roleChanges[role.id][meta.key]
                                    : role[meta.key]
                                }
                                onChange={(e) =>
                                  handlePermissionChange(
                                    role.id,
                                    meta.key,
                                    e.target.checked
                                  )
                                }
                                classes={{
                                  root: classes.checkboxRoot,
                                  checked: classes.checkboxCheckedClient,
                                  disabled: classes.checkboxDisabled,
                                }}
                              />
                            </TableCell>
                          ))}

                          <TableCell align="center">
                            <div className={classes.actionIconsCustom}>
                              <Tooltip
                                title={t("program_setup.actions.edit")}
                                arrow
                              >
                                {/* is_default check is redundant here but kept for safety */}
                                <span
                                  className={cx({
                                    [classes.actionDisabled]: role.is_default,
                                  })}
                                >
                                  <EditIcon
                                    className={classes.iconButtonCustom}
                                    onClick={() =>
                                      !role.is_default &&
                                      handleOpenRoleDrawer(role)
                                    }
                                  />
                                </span>
                              </Tooltip>
                              <Tooltip
                                title={t("program_setup.actions.delete")}
                                arrow
                              >
                                <span
                                  className={cx({
                                    [classes.actionDisabled]: role.is_default,
                                  })}
                                >
                                  <DeleteIcon
                                    className={classes.iconButtonCustom}
                                    onClick={() =>
                                      !role.is_default &&
                                      handleOpenDeleteDialog(
                                        "role",
                                        role.id,
                                        role.name
                                      )
                                    }
                                  />
                                </span>
                              </Tooltip>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPanel>

          {/* ================================= */}
          {/* TAB PANEL 2: USER MANAGEMENT      */}
          {/* ================================= */}
          <TabPanel value={managementTabValue} index={1}>
            <GridContainer
              justifyContent="space-between"
              alignItems="center"
              style={{ padding: "10px 0" }}
            >
              {/* The filter GridItem remains the same */}
              <GridItem xs={12} sm={6}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0 8px 0 8px", // Lower Padding Reduced
                  }}
                >
                  <div style={{ padding: "0px 0px 15px 0px" }}>
                    <TextField
                      label={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          {t("program_setup.filters.filter_users")}{" "}
                          <SearchIcon className={classes.searchIcon} />
                        </div>
                      }
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{
                        classes: { input: classes.inputText },
                        style: { fontSize: "12px" },
                      }}
                      InputLabelProps={{
                        classes: { root: classes.labelText },
                        shrink: true,
                      }}
                      value={userFilter}
                      onChange={(e) => handleUserFilterChange(e.target.value)}
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </GridItem>

              <GridItem xs={12} sm={6} style={{ textAlign: "right" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <Button
                    color="client"
                    size="sm"
                    onClick={handleOpenUserDrawer}
                    className={classes.cardButton}
                  >
                    <AddCircle className={classes.cardButtonIcon} />
                  </Button>

                  <Button
                    justIcon
                    color="client"
                    className={cx({
                      [classes.cardButton]: true,
                      [classes.attention]: hasChanges && !isSavingAllChanges,
                      [classes.actionDisabled]:
                        !hasChanges || isSavingAllChanges,
                    })}
                    onClick={handleSaveAllChanges}
                    disabled={!hasChanges || isSavingAllChanges}
                    // No need for marginLeft here anymore
                  >
                    {isSavingAllChanges ? (
                      <ThreeDots color="#FFF" height={15} width={15} />
                    ) : (
                      <Save className={classes.cardButtonIcon} />
                    )}
                  </Button>
                </div>
              </GridItem>
            </GridContainer>

            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeadCell}>
                      {t("program_setup.table_head.username")}
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      {t("program_setup.table_head.email")}
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      {t("program_setup.table_head.role")}
                    </TableCell>
                    <TableCell className={classes.tableHeadCell} align="center">
                      {t("program_setup.table_head.actions")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoadingUsers ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        <ThreeDots color={clientColor} height={40} width={40} />
                      </TableCell>
                    </TableRow>
                  ) : (
                    sortData(
                      systemUsers.filter((user) => {
                        // Ensure the filter term is in lower case
                        const filterText = userFilter.toLowerCase();

                        // Safely get user name and email, convert to lower case
                        const userName = (user.name || "").toLowerCase();
                        const userEmail = (user.email || "").toLowerCase();

                        // Return true if the filter text is found in either the name OR the email
                        return (
                          userName.includes(filterText) ||
                          userEmail.includes(filterText)
                        );
                      }),
                      sortConfigUsers
                    ).map((user) => (
                      <TableRow key={user.id}>
                        <TableCell>{user.name}</TableCell>
                        <TableCell>{user.email}</TableCell>
                        <TableCell style={{ minWidth: "200px" }}>
                          <FormControl
                            fullWidth
                            size="small"
                            variant="standard"
                          >
                            <TextField
                              select
                              value={
                                modifiedUserRoles[user.id] || user.role_id || ""
                              }
                              onChange={(e) =>
                                handleUserRoleChange(user.id, e.target.value)
                              }
                              disabled={
                                user.is_role_immutable || isSavingUserRoles
                              }
                              classes={{ root: classes.textFieldRoot }}
                              InputProps={{
                                classes: { input: classes.inputText },
                              }}
                              InputLabelProps={{
                                classes: { root: classes.labelText },
                              }}
                            >
                              <MenuItem
                                value=""
                                classes={{
                                  root: classes.selectMenuItem,
                                  selected: classes.selectMenuItemSelected,
                                }}
                              >
                                <em>{t("labels.no_role", "No Role")}</em>
                              </MenuItem>
                              {roles
                                .filter((r) => !r.is_default)
                                .map((role) => (
                                  <MenuItem
                                    key={role.id}
                                    value={role.id}
                                    classes={{
                                      root: classes.selectMenuItem,
                                      selected: classes.selectMenuItemSelected,
                                    }}
                                  >
                                    {role.name}
                                  </MenuItem>
                                ))}
                            </TextField>
                          </FormControl>
                        </TableCell>
                        <TableCell align="center">
                          <div className={classes.actionIconsCustom}>
                            <Tooltip
                              title={t("program_setup.actions.edit")}
                              arrow
                            >
                              <EditIcon
                                className={classes.iconButtonCustom}
                                onClick={() => handleEditSystemUser(user)}
                              />
                            </Tooltip>
                            <Tooltip
                              title={t("program_setup.actions.delete")}
                              arrow
                            >
                              <DeleteIcon
                                className={classes.iconButtonCustom}
                                onClick={() =>
                                  handleOpenDeleteDialog(
                                    "user",
                                    user.id,
                                    user.full_name
                                  )
                                }
                              />
                            </Tooltip>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </TabPanel>

          {/* ================================= */}
          {/* TAB PANEL 3: ACCESS GROUPS        */}
          {/* ================================= */}
          <TabPanel value={managementTabValue} index={2}>
            {/* This is the existing JSX for Access Groups, moved from the old TabPanel */}
            <GridContainer
              justifyContent="space-between"
              alignItems="center"
              className={classes.filterContainer}
            >
              <GridItem className={classes.filterItem} xs={12} sm={8}>
                <Box display="flex" alignItems="center">
                  {/* Filter icon */}
                  <FontAwesomeIcon
                    icon={faFilter}
                    style={{
                      marginRight: "8px",
                      fontSize: "20px",
                      color: "#666",
                    }}
                  />

                  {/* First Filter: Group Name */}
                  <FormControl
                    size="medium"
                    className={`${classes.selectFormControl} ${classes.selectFormControlOverride}`}
                  >
                    {/* Remove Inputlabel if not necessary */}
                    <Select
                      displayEmpty
                      classes={{
                        select: `${classes.select} ${classes.selectFormControlOverride}`,
                      }}
                      value={accessGroupFilterGroupName}
                      onChange={(e) =>
                        setAccessGroupFilterGroupName(e.target.value)
                      }
                    >
                      <MenuItem
                        value=""
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                      >
                        {t("program_setup.filters.all_accessgroups")}
                      </MenuItem>
                      {accessGroups.map((group) => (
                        <MenuItem key={group.id} value={group.groupName}>
                          {group.groupName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  {/* Spacing between the filters */}
                  <Box mx={1} />

                  {/* Second Filter: User */}
                  <div style={{ padding: "0px 0px 15px 0px" }}>
                    <TextField
                      label={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          {t("program_setup.filters.filter_users")}{" "}
                          {/* Field label */}
                          <SearchIcon className={classes.searchIcon} />
                        </div>
                      }
                      classes={{ root: classes.textFieldRoot }}
                      InputProps={{
                        classes: { input: classes.inputText },
                        style: { fontSize: "12px" },
                      }}
                      InputLabelProps={{
                        classes: { root: classes.labelText },
                        shrink: true,
                      }}
                      value={userFilter}
                      onChange={(e) => handleUserFilterChange(e.target.value)}
                      style={{ width: "100%" }}
                    />
                  </div>
                </Box>
              </GridItem>
              <GridItem>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <Button
                    color="client"
                    className={classes.cardButton}
                    onClick={handleOpenAccessGroupDrawer}
                  >
                    <AddCircle className={classes.cardButtonIcon} />
                  </Button>
                </Box>
              </GridItem>
            </GridContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.tableHeadCell}
                    onClick={() => handleSortAccessGroups("groupName")}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={classes.tableHeaderIcon}>
                      <span>{t("program_setup.table_head.group_name")}</span>
                      <FontAwesomeIcon
                        icon={
                          sortConfigAccessGroups.key === "groupName"
                            ? sortConfigAccessGroups.direction === "ascending"
                              ? faSortUp
                              : faSortDown
                            : faSort
                        }
                        className={
                          sortConfigAccessGroups.key === "groupName"
                            ? `${classes.sortIcon} ${classes.activeSortIcon}`
                            : classes.sortIcon
                        }
                      />
                    </div>
                  </TableCell>
                  <TableCell className={classes.tableHeadCell}>
                    {t("program_setup.table_head.users")}
                  </TableCell>
                  <TableCell className={classes.tableHeadCell} align="center">
                    {t("program_setup.table_head.actions")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoadingAccessGroups ? (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      <ThreeDots
                        color={clientColor}
                        height={80}
                        width={80}
                      />
                    </TableCell>
                  </TableRow>
                ) : (
                  sortData(accessGroups, sortConfigAccessGroups).map((g) => (
                    <TableRow key={g.id}>
                      <TableCell>{g.groupName}</TableCell>
                      <TableCell className={classes.ellipsisCell}>
                        <Tooltip
                          title={
                            // The `g.users` is now an array of objects: [{id, full_name, email}, ...]
                            g.users.map((user) => user.full_name).join(", ")
                          }
                          arrow
                        >
                          <span>
                            {g.users.map((user) => user.full_name).join(", ")}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">
                        <div className={classes.actionIconsCustom}>
                          <Tooltip
                            title={t("program_setup.actions.edit")}
                            arrow
                          >
                            <EditIcon
                              className={classes.iconButtonCustom}
                              onClick={() => handleEditAccessGroup(g)}
                              size="small"
                            />
                          </Tooltip>
                          <Tooltip
                            title={t("program_setup.actions.delete")}
                            arrow
                          >
                            <DeleteIcon
                              className={classes.iconButtonCustom}
                              onClick={() =>
                                handleOpenDeleteDialog(
                                  "accessGroup",
                                  g.id,
                                  g.groupName
                                )
                              }
                              size="small"
                            />
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TabPanel>
        </AccordionDetails>
      </Accordion>
      {/* ==================================================================== */}
      {/* END: REFACTORED ACCORDION                                            */}
      {/* ==================================================================== */}

      <Drawer
        anchor="right"
        open={roleDrawerOpen}
        onClose={handleCloseRoleDrawer}
        // Added BackdropProps and PaperProps for consistent styling with the Access Group Drawer
        BackdropProps={{
          style: { backgroundColor: "#000", opacity: "0.1" },
        }}
        PaperProps={{
          style: {
            borderRadius: "10px",
            margin: "1vh 1vh 1vh 0",
            height: "98vh",
          },
        }}
      >
        <div className={classes.drawer}>
          <Typography variant="h6" gutterBottom>
            {editingRoleId
              ? t("program_setup.roles.drawer.edit_title")
              : t("program_setup.roles.drawer.create_title")}
          </Typography>
          <form noValidate autoComplete="off">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t("program_setup.roles.drawer.name")}
                  name="name"
                  value={newRole.name}
                  onChange={handleRoleFormChange}
                  // Ensuring all TextFields have the same style classes
                  classes={{ root: classes.textFieldRoot }}
                  InputProps={{ classes: { input: classes.inputText } }}
                  InputLabelProps={{ classes: { root: classes.labelText } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t("program_setup.roles.drawer.description")}
                  name="description"
                  value={newRole.description}
                  onChange={handleRoleFormChange}
                  multiline
                  rows={3}
                  // Ensuring all TextFields have the same style classes
                  classes={{ root: classes.textFieldRoot }}
                  InputProps={{ classes: { input: classes.inputText } }}
                  InputLabelProps={{ classes: { root: classes.labelText } }}
                />
              </Grid>
            </Grid>
          </form>

          {/* The bottom save button is replaced by the icon button at the top right */}
          <GridItem
            style={{
              zIndex: 1000,
              position: "absolute",
              right: "15px",
              top: "10px",
            }}
          >
            <Button
              justIcon
              color="client"
              className={classes.cardButton}
              onClick={handleSaveRole}
              disabled={!newRole.name} // Example disabled logic
            >
              <Save className={classes.cardButtonIcon} />
            </Button>
          </GridItem>
        </div>
      </Drawer>

      {/* ⭐️ UPDATED: User Drawer (Refactored for Style Consistency) */}
      <Drawer
        anchor="right"
        open={userDrawerOpen}
        onClose={handleCloseUserDrawer}
        // Added BackdropProps and PaperProps for consistent styling
        BackdropProps={{
          style: { backgroundColor: "#000", opacity: "0.1" },
        }}
        PaperProps={{
          style: {
            borderRadius: "10px",
            margin: "1vh 1vh 1vh 0",
            height: "98vh",
          },
        }}
      >
        <div className={classes.drawer}>
          <Typography variant="h6" gutterBottom>
            {editingSystemUserId
              ? t("program_setup.drawer.user.edit_title")
              : t("program_setup.drawer.user.title")}
          </Typography>

          {/* The Close button is replaced by the Save button at the top right */}
          {/*
    <Button onClick={handleCloseUserDrawer} className={classes.closeButton}>
      <CloseIcon />
    </Button>
    */}

          <form noValidate autoComplete="off">
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t("program_setup.drawer.user.fields.first_name")}
                  name="first_name"
                  value={newSystemUser.first_name}
                  onChange={handleSystemUserChange}
                  // Ensuring all TextFields have the same style classes
                  classes={{ root: classes.textFieldRoot }}
                  InputProps={{ classes: { input: classes.inputText } }}
                  InputLabelProps={{ classes: { root: classes.labelText } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t("program_setup.drawer.user.fields.last_name")}
                  name="last_name"
                  value={newSystemUser.last_name}
                  onChange={handleSystemUserChange}
                  // Ensuring all TextFields have the same style classes
                  classes={{ root: classes.textFieldRoot }}
                  InputProps={{ classes: { input: classes.inputText } }}
                  InputLabelProps={{ classes: { root: classes.labelText } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t("program_setup.drawer.user.fields.email")}
                  name="email"
                  value={newSystemUser.email}
                  onChange={handleSystemUserChange}
                  // Ensuring all TextFields have the same style classes
                  classes={{ root: classes.textFieldRoot }}
                  InputProps={{ classes: { input: classes.inputText } }}
                  InputLabelProps={{ classes: { root: classes.labelText } }}
                />
              </Grid>

              {/* NEW: Role selection in user drawer */}
              <Grid item xs={12}>
                <FormControl fullWidth variant="standard">
                  {/* The label is manually set to follow the TextField style */}
                  <label
                    id="role-select-label"
                    className={classes.labelText}
                    style={{ fontSize: "0.8rem" }} // Adjust font size as needed
                  >
                    {t("program_setup.table_head.role")}
                  </label>
                  <TextField
                    label="role-select-label"
                    select
                    name="role_id"
                    value={newSystemUser.role_id || ""}
                    onChange={handleSystemUserChange}
                    classes={{ root: classes.textFieldRoot }}
                    InputProps={{ classes: { input: classes.inputText } }}
                    InputLabelProps={{ classes: { root: classes.labelText } }}
                  >
                    <MenuItem
                      value=""
                      classes={{
                        // Mantenha seus estilos de MenuItem
                        root: classes.selectMenuItem,
                        selected: classes.selectMenuItemSelected,
                      }}
                    >
                      <em>{t("labels.no_role")}</em>
                    </MenuItem>
                    {roles
                      .filter((r) => !r.is_default)
                      .map((role) => (
                        <MenuItem
                          key={role.id}
                          value={role.id}
                          classes={{
                            // Mantenha seus estilos de MenuItem
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                        >
                          {role.name}
                        </MenuItem>
                      ))}
                  </TextField>
                </FormControl>
              </Grid>
            </Grid>
          </form>

          {/* The bottom save button is replaced by the icon button at the top right */}
          <GridItem
            style={{
              zIndex: 1000,
              position: "absolute",
              right: "15px",
              top: "10px",
            }}
          >
            <Button
              justIcon
              color="client"
              className={classes.cardButton}
              onClick={handleSaveSystemUser}
              disabled={!newSystemUser.email} // Example disabled logic
            >
              <Save className={classes.cardButtonIcon} />
            </Button>
          </GridItem>
        </div>
      </Drawer>
      {/* Drawers for Access Group Registration */}
      <Drawer
        anchor="right"
        open={accessGroupDrawerOpen}
        onClose={() => {
          const isEditing = editingAccessGroupId !== null;
          if (isEditing && hasUnsavedAccessGroupChanges) {
            setOnDiscardConfirm(() => () => {
              handleCloseAccessGroupDrawer();
            });
            setOnDiscardCancel(() => () => {
              setAccessGroupDrawerOpen(true);
            });
            setUnsavedDialogOpen(true);
          } else {
            handleCloseAccessGroupDrawer();
          }
        }}
        BackdropProps={{
          style: { backgroundColor: "#000", opacity: "0.1" },
        }}
        PaperProps={{
          style: {
            // Opacity: "0.95",

            borderRadius: "10px",
            margin: "1vh 1vh 1vh 0",
            height: "98vh",
          },
        }}
      >
        <div className={classes.drawer}>
          <Typography variant="h6" gutterBottom>
            {editingAccessGroupId !== null
              ? t("program_setup.drawer.access_group.edit_title")
              : t("program_setup.drawer.access_group.title")}
          </Typography>
          <form noValidate autoComplete="off">
            <Grid container spacing={2}>
              {/* Group name */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label={t(
                    "program_setup.drawer.access_group.fields.groupName"
                  )}
                  name="groupName" // Adjusted to use the correct key
                  value={newAccessGroup.groupName}
                  onChange={handleAccessGroupChange}
                  classes={{ root: classes.textFieldRoot }}
                  InputProps={{ classes: { input: classes.inputText } }}
                  InputLabelProps={{ classes: { root: classes.labelText } }}
                />
              </Grid>

              {/* Selection of Access Group members */}
              <Grid item xs={12}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <ReactSelect
                    isMulti
                    options={systemUsers.map((user) => ({
                      value: user.id,
                      // 1. FIX for "undefined" name in options list
                      label: `${user.name} (${user.email})`,
                    }))}
                    value={
                      // This logic now works because newAccessGroup.users is an array of IDs
                      newAccessGroup.users
                        .map((userId) => {
                          const user = systemUsers.find((u) => u.id === userId);
                          return user
                            ? {
                                value: user.id,
                                // 2. FIX for correctly displaying selected users on edit
                                label: `${user.name} (${user.email})`,
                              }
                            : null;
                        })
                        .filter(Boolean) // Removes null values if a user was deleted but still in a group
                    }
                    onChange={(selectedOptions) => {
                      // This part was already correct, it extracts IDs to update the state
                      const selectedIds = selectedOptions.map(
                        (option) => option.value
                      );
                      setNewAccessGroup((prev) => ({
                        ...prev,
                        users: selectedIds,
                      }));
                      // Mark changes if editing
                      if (editingAccessGroupId !== null) {
                        setHasUnsavedAccessGroupChanges(true);
                      }
                    }}
                    styles={customStyles}
                    placeholder={t(
                      "program_setup.drawer.access_group.fields.select_label"
                    )}
                    closeMenuOnSelect={false}
                  />
                </FormControl>
              </Grid>

              {/* Save button */}
              <GridItem
                style={{
                  zIndex: 1000,
                  position: "absolute",
                  right: "15px",
                  top: "10px",
                }}
              >
                <Button
                  justIcon
                  color="client"
                  className={classes.cardButton}
                  onClick={handleSaveAccessGroup}
                  disabled={!newAccessGroup.groupName}
                >
                  <Save className={classes.cardButtonIcon} />
                </Button>
              </GridItem>
            </Grid>
          </form>
        </div>
      </Drawer>
    </div>
  );
}

ProgramSetup.propTypes = {
  // Add proptypes as needed
};
